var pdpPreviousLugWidthValue = '';
$(function(){
  onLoadPullAndChangeLugWidth();
  tierGwp();
  tierGwpQtyChecking();
  tierGwpOrderAttr();
  updatePreorderProps();
  updatePickupLocationProps();
    initProductGridImgSlider();
    retrievePageContents();
    cartJSevent();
    addonFlickity();
    addonFlickity2();
    badgedProductsFlickity();
    checkCustomerStatus(); 
    onloadUpdateStrapSelectorWidth();
    sliderGridHeight();
    sliderBlogGridHeight();
    externalLinkNewTab();
    pdpSliderGridHeight();
    initFeaturedBlogSlider();
    detectUserTimezone();
    onLoadToggleSizeSelector();
    onLoadDisabledOosAddOnVariant();
    mobileFlickity();
    enableInStockFilter();
    onloadAccountGallery();
    updateAnnouncementCurrencySelector();
    initPropertiesSlider();
    initTagPageSlider();
    initAddonImgSlider();
    mobileIconListFlickity();
    onloadCheckLugWidth();
    updateBuckleOption();
    removeWatchModelOptions();
    updateStrapDeliveryPropertyInCart();
    initWidthFieldsetByColour();
    // Initialize mobile listeners for width fieldset (will only initialize if on mobile)
    initMobileWidthFieldsetListeners();

    onloadWatchSection();
    redirectPageHideSearch();
    hardRedirection();
    //Start Addon PDP feature
    var $addonWrap = $('.jsc-product__addon-wrap.jsc-addon-inline-select');
    if($addonWrap.length > 0) {
      $( ".jsc-product__addon-grid" ).on( "click", function( event ) {
        console.log(event.target);
        if($(this).hasClass('addon-oos')) {
          event.preventDefault();
        }
        else {
          if ($(event.target).hasClass('jsc-single-selector') || $(event.target).hasClass('dont_toggle')) {
            console.log('dont toggle');
          }else{
              $( this ).toggleClass('addon-active');
              if ($( this ).find('.addon-install').is(':checked') && $( this ).hasClass('addon-active') == false) {
                $( this ).find('.addon-install').prop('checked',false);
              }
              if ($( this ).hasClass('addon-active') == false) {
                $('.jsc-addon-warning').text('');
                $( this ).find('.jsc-single-selector').removeClass('border-red');
              }

          }
        }
      });
    }
    //End Addon PDP feature

    if (window.location.href.includes('/account?order-gallery')){
      loadOrderGalleryFilter();
      loadOrderGallery();
    }
});

updateStrapDeliveryPropertyInCart = () => {
  $('._cart-update-strap-delivery').each(function(){

      var _vid = parseInt($(this).attr('data-vid'));
      var _deliverydate = $(this).attr('data-date');

      $.getJSON('/cart.js', function(cart) {
  
        for (var i = 0; i < cart.items.length; i++) {
          var cart_vid = cart.items[i].id;
          var cart_qty = cart.items[i].quantity;
          var cart_deliverydate = cart.items[i].properties['Estimated Delivery'];
          var $properties = cart.items[i].properties;
  
          if (_vid == cart_vid) {
            if (_deliverydate != cart_deliverydate) {
              $properties['Estimated Delivery'] = _deliverydate;
  
              CartJS.updateItemById(cart.items[i].key,cart_qty,$properties);
            }
          }
        }
     });
   });
}

hardRedirection = () => {
  var currentURL = window.location.href;
  var rules = window.hardRedirectionRules || [];

  rules.forEach(rule => {
    if (currentURL == rule.currentPath) {
      window.location.href = rule.targetUrl;
    }
  });
}
redirectPageHideSearch = () => {
  var redirect_url= $('#__getPageRedirect').attr('redirect-url');
  if (redirect_url){
    document.location.href = redirect_url;
  }
}

onloadWatchSection = () => {
  var url = window.location.href;
  
  // Check if URL contains '?page=' parameter
  if (url.includes('?page=')) {
    // append loader
    var $html = `<div class="jsc-page-loading">
    <div class="jsc-spinner-container">
    <div class="jsc-spinner"></div>
    </div>
    </div>`;
    $('body').prepend($html);

      // Split the URL string by '?page='
      var parts = url.split('?page=');
      // Get the value after '?page='
      var pageHandle = parts[1].split('?')[0];

      $.ajax({
        url: `/pages/${pageHandle}`,
        cache: false,
        success: function(response) {
       
  
        // console.log("SUCCESS",response);
          // Convert response into a jQuery object
          var $response = $(response);
  
          // Find the content you want to append
          var $contentToAppend = $response.find('#main-content').html();
  
          // Append the content to the collection page
          $('#ProductGridContainer').parents('.shopify-section').prepend($contentToAppend);
          
          // Remove loader
          $('.jsc-page-loading').remove();
        },
        error: function() {
         console.log("ERROR");
        // Remove loader
        $('.jsc-page-loading').remove();
                    
        }
      });
  } else {
      // '?page=' parameter not found
      // console.log('URL does not contain ?page= parameter');
  }

}

// Start Order Gallery 

loadOrderGalleryFilter = () => {
  var jsonDataString = $('#_order_galleryArr').val();
  var jsonData = JSON.parse(jsonDataString);
  var orderArray = jsonData.ordergallery;
  const uniqueTagsSet = new Set();
  
  // Iterate through each object in the 'orderarray' 
  $.each(orderArray, function(index, item) {
      // Add tags to the uniqueTagsSet
      if (item.tags) {
        item.tags.split('>').forEach(tag => {
          if (tag.trim()) { // Check if the tag is not empty
            uniqueTagsSet.add(tag.trim());
          }
        });
      }
  });
  
  // Convert uniqueTagsSet to an array
  const uniqueTagsArray = Array.from(uniqueTagsSet);
  
  // Append the unique tags to a new div
   const tagsDiv = $('.jsc-order-gallery__tags--inner'); // Assuming you have a div with id 'tags-div'
  
  // Get the filter values and filter texts from the hidden input
  const filterValues = $('#_order_galleryArr').attr('filter-value').split(',');
  const filterTexts = $('#_order_galleryArr').attr('filter-text').split(',');
  // console.log(filterValues,'filterValues');
  // console.log(filterTexts,'filterTexts');
  
  uniqueTagsArray.forEach(tag => {
    // Replace spaces or symbols with hyphens and convert to lowercase
    const sanitizedTag = tag.replace(/ & /g, '-').replace(/\s+/g, '-').toLowerCase();
    // Find the index of the tag in the filterValues array
    const index = filterValues.indexOf(tag);
    // Get the corresponding filter text for the tag
    const filterName = index !== -1 ? filterTexts[index] : tag;
    // Create an <a> element with the sanitized tag and set href attribute to lowercase
    const tagLink = `<a class="tag" href="/account?order-gallery/tagged/${sanitizedTag}" tag-value="${sanitizedTag}">${filterName}</a>`;
    tagsDiv.append(tagLink);
  });  
}

loadOrderGallery = () => {
  var jsonDataString = $('#_order_galleryArr').val();
  var jsonData = JSON.parse(jsonDataString);
  var orderArray = jsonData.ordergallery;
  const combinationMap = {};

  // Get the current URL
  var currentUrl = window.location.href;

  // Split the URL by "/"
  var urlSegments = currentUrl.split('/');

  // Find the index of "tagged" in the URL segments
  var taggedIndex = urlSegments.indexOf("tagged");

  // Initialize dynamicValue
  var dynamicValue = null;

  // If "tagged" is found in the URL segments
  if (taggedIndex !== -1 && taggedIndex + 1 < urlSegments.length) {
      // Get the value after "tagged/"
      dynamicValue = urlSegments[taggedIndex + 1];
      // console.log(dynamicValue); // Output the dynamic value
  } else {
      // console.log("No value found after 'tagged/'");
  }

  $('.jsc-order-gallery__tags--inner a.tag').each(function() {
    var tagValue = $(this).attr('tag-value');
    $(this).removeClass('active');
    if (tagValue == dynamicValue) {
      $(this).addClass('active');
    } else {
      $(this).removeClass('active');
    }
  });

  // Iterate through each object in the 'orderarray' 
  $.each(orderArray, function(index, item) {
    // Convert item.tags to lowercase and replace whitespace with hyphens
    var lowercaseTags = item.tags.toLowerCase().replace(/ & /g, '-').replace(/\s+/g, '-').split('>');

    // Check if the dynamicValue is present in lowercaseTags
    var includeItem = !dynamicValue || lowercaseTags.includes(dynamicValue);

    if (includeItem) {
      // Generate a key based on the combination of title and vtitle
      var key = item.title + ',' + item.vtitle;

      // Check if the combination already exists in the map
      if (combinationMap.hasOwnProperty(key)) {
        // If it exists, append the order_no to the existing array
        combinationMap[key].orderNos.push(item.order_no);
      } else {
        // If it doesn't exist, create a new array with the order_no
        combinationMap[key] = {
          prodHandle: item.handle,
          prodImg: item.prod_img,
          orderNos: [item.order_no],
          orderId: item.order_id,
        };
      }
    }
  });

  // Convert the combinationMap and push data into the tableHTMLArray
  const tableHTMLArray = [];
  for (const key in combinationMap) {
    if (combinationMap.hasOwnProperty(key)) {
      const { prodImg, orderNos, orderId, prodHandle } = combinationMap[key];
      const orderNosString = orderNos.join(': '); // Combine order numbers
      tableHTMLArray.push(`${prodImg} , ${key} , ${orderNosString} , ${orderId}, ${prodHandle}`);
    }
  }

  // Check if dynamicValue is not empty and tableHTMLArray is empty
   if (dynamicValue != '' & tableHTMLArray.length == 0) {
      window.location.href = '/account?order-gallery';
      return; // Exit the function to prevent further execution
    }

  // console.log(tableHTMLArray, 'tableHTMLArray');
  // Load the ul with pagination
  loadTableRow(tableHTMLArray, 1);
}

// Function to load li with pagination
loadTableRow = (htmlArray, page) => {
  const galleryContainer = $('#jsc-order-grids');

  // If the gallery container doesn't exist or no data to display, hide the section and return
  if (!galleryContainer.length || htmlArray.length === 0) {
    galleryContainer.parents('.jsc-section').hide();
    return;
  }

  // Define pagination limits
  const perPageLimit = 20;
  const totalPaginationNum = Math.ceil(htmlArray.length / perPageLimit);
  const currentPageToShow = page;
  const arrayStartIndex = (currentPageToShow - 1) * perPageLimit;
  const arrayEndIndex = Math.min(currentPageToShow * perPageLimit, htmlArray.length);

  // Get the ul element
  const tbody = galleryContainer.find('ul');

  // Loop through the array and append li element to the ul 
  for (let index = arrayStartIndex; index < arrayEndIndex; index++) {
    // Split the string by comma to get individual parts
    const parts = htmlArray[index].split(',');

    // Create a new div element to contain the parts
    const $container = $('<li class="column"></li>');

    // Create the product card
    const $productCard = $('<product-card class="product-card text-left product-card--content-spacing-true product-card--border-false has-shadow--true"></product-card>');

    // Create the figure
    const $figure = $('<figure class="product-featured-image"></figure>');

    // Replace the "20x20_crop_center" part with the desired dimensions
    const srcset298 = parts[0].trim().replace('small_crop_center.jpg', '298x298.jpg') + ' 298w';
    const srcset596 = parts[0].trim().replace('small_crop_center.jpg', '596x596.jpg') + ' 596w'; 

    // Construct the data-srcset attribute value
    const srcset = `${srcset298}, ${srcset596}`;

    // Create the image element
    const $img = $('<img>').attr({
      src: parts[0].trim(), // prod_img
      srcset: srcset,
      alt: 'Product Image',
      class: 'product-primary-image lazyautosizes lazyloaded',
      width: '2048',
      height: '2048',
      'data-sizes': 'auto',
      'data-srcset': srcset
      
    });

    // Create the anchor element
    const $a = $('<a>').attr({
      href: '/products/' + parts[5].trim(), // item.title
      title: parts[0], // item.title
      class: 'product-featured-image-link aspect-ratio aspect-ratio--square',
      style: '--padding-bottom: 100%;'
    });

    // Append the image to the anchor
    $a.append($img);

    // Append the anchor to the figure
    $figure.append($a);

    // Create the product info
    const $productInfo = $('<div class="product-card-info"></div>');

    // Create the title element
    const $title = $('<div class="product-card-title"></div>').text(parts[1]); // item.title

    // Create the variant element
    const $variant = $('<div class="m-b-10 jsc-og-product-card-variant"></div>');

    // Check if parts[2] contains the default title
    if (parts[2].trim() === 'Default Title' || parts[2].trim() === '') {
      // If it's the default title, add the d-none class
      $variant.css('visibility', 'hidden');
    }

    // Set the text for the variant element
    if (parts[2].trim() === '') {
      $variant.text('Empty');
    }else{
      $variant.text(parts[2]);
    }


    // Check if parts[3] contains multiple order numbers separated by colon
    const orderNumbers = parts[3].trim().split(':');

    // Create a div element to contain the order number(s)
    const $orderNo = $('<div></div>');

    if (orderNumbers.length > 1) {
      // If there are multiple order numbers, create a div for each one
      orderNumbers.forEach(orderNo => {
        const $orderDiv = ('<a class="fontWeight-6 underline-text-deco jsc-og-product-card-order-name" href="https://delugs.com/account/orders/'+ parts[4].trim() +'">Order ' + orderNo + '</a> ');
        $orderNo.append($orderDiv);
      });
    } else {
      // If there's only one order number, create a single div for it
      $orderNo.html('<a class="fontWeight-6 underline-text-deco jsc-og-product-card-order-name" href="https://delugs.com/account/orders/' +  parts[4].trim() + '">Order ' + orderNumbers[0] + '</a>');
    }

    // Append elements to product info
    $productInfo.append($title);
    $productInfo.append($variant);
    $productInfo.append($orderNo);

    // Append elements to product card
    $productCard.append($figure);
    $productCard.append($productInfo);

    // Append product card to container
    $container.append($productCard);

    // Append the container to the ul element
    tbody.append($container);
  }

  // Update pagination index
  updatePaginationIndex(totalPaginationNum, currentPageToShow, htmlArray);
};


// Function to update pagination index
updatePaginationIndex = (totalPage, activePage, htmlArray) => {
  const paginationContainer = $('#jsc-pagination-container');
  const paginationPages = paginationContainer.find('.jsc-pagination-pages');
  
  // Check if htmlArray has more than 20 elements
  if (htmlArray.length > 20){
    // Loop through the total number of pages
    for (let index = 1; index <= totalPage; index++) {
        // If it's the active page, add a current page class
        if (index === activePage) {
            paginationPages.append(`<span class="jsc-currentPage jsc-pagination-index m-l-10 m-r-10">${index}</span>`);
        } else {
            // Add pagination index with onclick function to paginate
            paginationPages.append(`<span class="jsc-pagination-index cursor m-l-10 m-r-10 " onclick="paginate('${htmlArray.join('---')}',${index})">${index}</span>`);
        }
    }
  }
};

// Function to paginate and load new li elements
paginate = (htmlString, pageIndex) => {
  const galleryContainer = $('#jsc-order-grids');
  const htmlArray = htmlString.split('---');

  // Remove existing li elements and pagination
  galleryContainer.find('ul').children().remove();
  galleryContainer.find('.jsc-pagination-pages').children().remove();

  // Load new li elements with pagination
  loadTableRow(htmlArray, pageIndex);
};

onloadAccountGallery = () => {
  var currentUrl = window.location.href;
  if (currentUrl.includes('/account?order-gallery')) {
    $('#_gallery_btn').addClass('active');
    $('.breadcrumbs.account').hide();
    $('.template-header').hide();
    $('#_jscAccount').hide();
    $('#_jscOrderGallery').show();
  }else if (currentUrl.includes('/account?watch-collection')) {
    $('#_saved_watch_btn').addClass('active');
    $('.breadcrumbs.account').hide();
    $('.template-header').hide();
    $('#_jscAccount').hide(); 
    $('#_jscOrderGallery').parent().remove();
    $('#_jscSavedWatchesList').show();
  }else if (currentUrl.includes('/account')) {
    $('#_acc_btn').addClass('active')
    $('#_jscOrderGallery').parent().remove();
    $('.breadcrumbs.account').show();
    $('.template-header').show();
    $('#_jscAccount').show();
  }
}
// End Order Gallery 


mobileFlickity = () =>{
  var $mobFlickity = $('.jsc-mob-flickity');

  if ($(window).width() < 481 && $mobFlickity.length > 0) {
      var thumbIndex = $('.jsc-swatch-opt.active').attr('data-index');
      var $childCount = $mobFlickity.children().length;
      
      if ($childCount > 13) {
        $mobFlickity.parent().addClass('jsc-mob-sibling-wrapper');
        $mobFlickity.flickity({
            // options
            cellAlign: 'center',
            draggable: true,
            contain: true,
            pageDots: false,
            imagesLoaded: true,
            adaptiveHeight: false,
            prevNextButtons: true,
            wrapAround: true
        });

        $mobFlickity.flickity('select', thumbIndex );
      }
   }
}

tierGwpOrderAttr = () => {
  var $gwpFullyRedeem = $('.jsc-gwp-fully-redeemed');
  $.when($.getJSON('/cart.js', function(cart) {
  })).then(function(cart){
      var cartAttr = cart.attributes;
      if ($gwpFullyRedeem.length == 0){
        if (cartAttr.hasOwnProperty('GWP Fully Redeemed') && cartAttr['GWP Fully Redeemed'] === "true") {
            CartJS.setAttributes({"GWP Fully Redeemed":"false/na"});
         }
      }
      else{
        if (!cartAttr.hasOwnProperty('GWP Fully Redeemed')){
          CartJS.setAttributes({"GWP Fully Redeemed":"true"});
        }
        else if(cartAttr.hasOwnProperty('GWP Fully Redeemed') && cartAttr['GWP Fully Redeemed'] === "false/na") {
          CartJS.setAttributes({"GWP Fully Redeemed":"true"});
        }
    }
  });    
}

externalLinkNewTab = () => {
  var links = document.links;
  // console.log(links, 'links');
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
}

// Start - ported over from Delugs Flex theme
retrievePageContents = () => {
    if ($('.display-tag-pages__container').length > 0) {
            var pages = $('.display-tag-pages__container').attr('pages');
            pages = pages.split(',');
            var all_page_requests = [];
            var all_page_content = [];
            for (let i = 0; i < pages.length; i++) {
              all_page_content.push([]);
              var handle = pages[i].split('_');
              handle = handle[1];
              if ($(`[tag="${pages[i]}"]`).length > 0) {
                var page_request = $.ajax({
                  url: `/pages/${handle}`,
                  cache: false,
                  success: function(response) {
                    all_page_content[i].push(response);
                    // console.log("SUCCESS");
                  },
                  error: function() {
                    var index = 0;
                    var match = false;
                    for (let i = 0; i < all_page_requests.length; i++) {
                      if (all_page_requests[i] == page_request) {
                        match = true;
                        index = i;
                        all_page_requests[i].abort();
                        break;
                      }
                    }
                    if (match) {
                      all_page_requests.splice(1,all_page_requests.length - 1);
                    }
                  }
                });
                all_page_requests.push(page_request);
              }
          
            }
            $.when.apply($, all_page_requests).done(function() {
              // console.log("ALL PAGE CONTENT LOADED");
              for (let i = 0; i < all_page_content.length; i++) {
                var item = pages[i].split('_');
                handle = item[1];
                var position = item[2];
                // console.log("OUTPUT: " + pages[i]);
                var page_content = $(`${all_page_content[i]}`).find('.jsc--product-feature');
                $(`.display-tag-pages__container [tag="details_${handle}_${position}"]`).append(page_content);
              }
              $('.display-tag-pages__page-container').each(function(){
                var image_position = $(this).attr('image');
                // var title = $(this).attr('title');
                // var description = $(this).find('.product-feature__description .description_content').attr('content');
                if (image_position === 'left') {
                  $(this).find('.product-feature__description').css('order', '1');
                }
                $(this).find('p').each(function(){
                  if ($(this).html() == '&nbsp;') {
                    $(this).remove();
                  } else {
                    if ($(this).find('img').length > 0) {
                      $(this).addClass('product-feature__image jsc-flex-wrap--container text-center');
                      $(this).find('img').wrap('<div class="responsive-image_wrapper"></div>')
                      if (image_position === 'right') {
                        $(this).addClass('medium-order-1');
                      }
                    } 
                    // else if ($(this).find('iframe').length > 0) {
                    //   $(this).addClass('product-feature__image jsc-flex-wrap--container text-center');
                    //   $(this).find('iframe').wrap('<div class="responsive-image_wrapper"></div>')
                    //   if (image_position === 'right') {
                    //     $(this).addClass('medium-order-1');
                    //   }
                    // }
                     else {
                      $(this).remove();
                    }
                  }
                });
              });
            });
    }
}  
// End - ported over from Delugs Flex theme


// Start CartJS Function
cartJSevent = () =>{
  $(document).on('cart.requestStarted', function(event, cart) {
    $('.jsc-checkout').attr('disabled',true); 
  });

  $(document).on('cart.requestComplete', function(event, cart) {
    $('.jsc-checkout').removeAttr('disabled');
    if (location.href.includes('/cart')) {
      location.reload();
      // fetch(window.location.pathname + "?sections=template--14704857841777__main-cart")
      // .then(res => res.json())
      // .then((restext) => {
      //   $('#shopify-section-template--14704857841777__main-cart').children().remove();
      //   $('#shopify-section-template--14704857841777__main-cart').html(restext["template--14704857841777__main-cart"]);
      // });
    }else{
      fetch(window.location.pathname + "?sections=cart-drawer")
      .then(res => res.json())
      .then((restext) => {

          const newHtml = $(restext["cart-drawer"]);
          const specificElementContent = newHtml.find('.cart-drawer').html();
  
          $('#Cart-Drawer').children().remove();
          $('#Cart-Drawer').html(specificElementContent);
  
        if (document.getElementById('Cart-Drawer')) {
              $('.side-panel.cart-drawer').addClass('active');
              document.getElementById('cart-drawer-toggle').dispatchEvent(new Event('click'));
          }


      });
  }
  });
}
cartJSAddQuery = (vid, qty, obj, isOpenDrawer) => {
// Cart js add item, success callback, error callback
console.log(vid,qty,obj,'testing');
  CartJS.addItem(vid, qty, obj,
  {
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {
          console.log('success');
              
      },
      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
      }
  });
}
  
cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer) => {
// Cart js add item, success callback, error callback

  CartJS.updateItemById(vid, qty, obj,
  {
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {
          console.log('success');
          
      },
      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
      $('.jsc-checkout').attr('disabled',false); 
      }
  });
}
// End CartJS Function

// Start Location Property Functions (SG Pickup Only)
// Update Location properties for all cart items on page load
// ADD Location property if metafield conditions met but property missing
// REMOVE Location property if metafield conditions no longer met
// Products tagged with 'x-pick-msg' are excluded from this logic
updatePickupLocationProps = () => {
  var locationMessage = 'This item is only available for pickup at our SG boutique and cannot be shipped.';

  $('.jsc-update-pickup-location').each(function() {
    var key = $(this).attr('data-key');
    var sgOnlineInventory = $(this).attr('data-sg-online-inventory');
    var posInventory = $(this).attr('data-pos-inventory');
    var isExcluded = $(this).attr('data-excluded') === 'true';
    var currencyIso = $(this).attr('data-currency-iso');

    // Location should exist only when: sgOnlineInventory === 'False' AND posInventory === 'True'
    // Products tagged with 'x-pick-msg' should NEVER have Location property
    var shouldHaveLocation = !isExcluded && sgOnlineInventory === 'False' && posInventory === 'True' && currencyIso === 'sgd';

    $.getJSON('/cart.js', function(cart) {
      for (var i = 0; i < cart.items.length; i++) {
        var itemKey = cart.items[i].key;
        var itemQty = cart.items[i].quantity;
        var itemProps = cart.items[i].properties || {};
        var hasLocation = itemProps['Location'];

        if (key == itemKey) {
          // Add Location if should have but doesn't
          if (shouldHaveLocation && !hasLocation) {
            itemProps['Location'] = locationMessage;
            CartJS.updateItemById(itemKey, itemQty, itemProps);
          }
          // Remove Location if shouldn't have but does
          else if (!shouldHaveLocation && hasLocation) {
            // Build new properties object WITHOUT Location
            var newProps = {};
            for (var propKey in itemProps) {
              if (propKey !== 'Location') {
                newProps[propKey] = itemProps[propKey];
              }
            }
            
            var isEmpty = Object.keys(newProps).length === 0;
            console.log(itemKey, 'newProps', newProps, 'isEmpty:', isEmpty);
            
            if (isEmpty) {
              // Only has Location prop - must remove and re-add item without property
              // (Shopify/CartJS limitation: cannot update props when item only has one property)
              var variantId = cart.items[i].variant_id;
              var quantity = itemQty;
              
              // Remove item first
              CartJS.updateItemById(itemKey, 0, {}, {
                success: function() {
                  // Re-add item without Location property
                  CartJS.addItem(variantId, quantity);
                }
              });
            } else {
              // Has other props - use reconstructed props (entirely removes Location)
              CartJS.updateItemById(itemKey, itemQty, newProps);
            }
          }
        }
      }
    });
  });
}
// End Location Property Functions

//Start Addon PDP feature
showAddOnModal = (e) => {
  var $addonGrid = $(e).parents('.jsc-product__addon-grid');
  if($addonGrid.hasClass('addon-active')) {
    $addonGrid.removeClass('addon-active');
  }
  else {
    var id = $addonGrid.attr('data-id');
    var $modal = $('.jsc-addon-quick-view-modal[data-id="' + id + '"]');
    var $overlay = $('.jsc-modal-overlay');
  
    $modal.addClass('active');
    $overlay.show();
    $overlay.on('click', hideAddOnModal);
  }
}

hideAddOnModal = () => {
  var $modal = $('.jsc-addon-quick-view-modal.active');
  var $overlay = $('.jsc-modal-overlay');

  $modal.removeClass('active');
  $overlay.hide();
  $overlay.off('click', hideAddOnModal);
}

initAddonImgSlider = () => {
  var $modal = $('.jsc-addon-quick-view-modal');
  var $imageSlider = $($modal).find('.jsc-addon-image-slider');

  $imageSlider.each(function() {
    var imgHeight = $(this).find('.jsc-addon-image-slide:first').width() * 1.25;
    $(this).find('.jsc-addon-image-slide img').css('height', imgHeight + 'px');
  });

  $imageSlider.flickity({
    cellAlign: 'left',
    draggable: true,
    contain: true,
    pageDots: true,
    wrapAround: true,
    prevNextButtons: false,
    imagesLoaded: true
  });
}

addonFlickity = () =>{
  $('.jsc-product__addon-wrap.jsc-addon-quick-view').flickity({
      // options
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      groupCells: false,
      imagesLoaded: true,
      adaptiveHeight: false,
      prevNextButtons: true,
      wrapAround: false
  });
}

updateColorVariant = (e) => {
  var colorValue = $(e).attr('data-value');
  var $swatchContainer = $(e).parents('.jsc-addon-modal-varopt');
  var $modal = $(e).parents('.jsc-addon-quick-view-modal');

  $($swatchContainer).find('.jsc-addon-modal-selected').text(colorValue);
  $($swatchContainer).find('.jsc-addon-swatch-opt').removeClass('active');
  $(e).addClass('active');

  if($(e).hasClass('sold-out')) {
    $($modal).find('.jsc-addon-submit').attr('disabled', '');
  }
  else {
    $($modal).find('.jsc-addon-submit').removeAttr('disabled');
  }
}

getLugWidthValue = () => {
  var $lugWidthSelector = $('.jsc-main_pdp_var_field .lug-width-select').find('select');
  if($lugWidthSelector.length > 0) {
    var lugWidthValue = $lugWidthSelector.val();
    if(lugWidthValue != null && lugWidthValue.indexOf('-') != -1) {
      lugWidthValue = lugWidthValue.split('-')[1];
      if (lugWidthValue.indexOf("(") !== -1) {
        lugWidthValue = lugWidthValue.substring(0, index);
        lugWidthValue = lugWidthValue.trim() + 'mm';
      } else {
        lugWidthValue = lugWidthValue + 'mm';
      }
    }

    return lugWidthValue;
  }
}

getVariantOptionIndex = ($grid, optName) => {
  var addonJson = JSON.parse($($grid).attr('data-addon'));
  var variantOptions = addonJson.options;
  var index = -1;
  if(optName == 'Color' || optName == 'Colour') {
    if(variantOptions.indexOf('Color') != -1) {
      index = variantOptions.indexOf('Color');
    }
    else if(variantOptions.indexOf('Colour') != -1) {
      index = variantOptions.indexOf('Colour');
    }
  }
  else {
    index = variantOptions.indexOf(optName);
  }

  if(index != -1) {
    index ++;
  }

  return index;
}

onloadCheckLugWidth = () => {
  var $addonWrap =  $('.jsc-product__addon-wrap.jsc-addon-quick-view');
  if($addonWrap.length > 0) {
    var $lugWidthSelector = $('.jsc-main_pdp_var_field .lug-width-select').find('select');
    if($lugWidthSelector.length > 0) {
      var lugWidthValue = getLugWidthValue();
      pdpPreviousLugWidthValue = lugWidthValue;
      var $addOnGrids = $('.jsc-product__addon-grid');
      var $warningText = $('.jsc-addon-warning');
      if(lugWidthValue == null) {
        $addOnGrids.addClass('addon-oos');
        $warningText.text('Please select your lug-width before selecting add-ons');
      }
      else {
        disabledOosAddOnVariant($lugWidthSelector);
      }
    }
  }
}

lugWidthOnChange = (e) => {
  var $addOnGrids = $('.jsc-product__addon-grid');
  var $activeAddonGrids = $('.jsc-product__addon-grid.addon-active');
  var $warningText = $('.jsc-addon-warning');
  var $errorPopup = $('.jsc-pdp-error-popup');
  var lugWidthValue = getLugWidthValue();

  // hide warning and enable add-on selection, remove all selected add-on
  $warningText.text('');
  if(pdpPreviousLugWidthValue != lugWidthValue && pdpPreviousLugWidthValue != null && pdpPreviousLugWidthValue != '' && $activeAddonGrids.length > 0) {
    $($errorPopup).find('.jsc-error-msg').text('');
    $($errorPopup).find('.jsc-addon-instruction').text('Please note that changing lug width will remove all selected add-ons.');
    $errorPopup.show();
    $addOnGrids.removeClass('addon-active');
  }
  pdpPreviousLugWidthValue = lugWidthValue;
  $addOnGrids.removeClass('addon-oos');
  disabledOosAddOnVariant($(e));
}

removeAlladdon = (keylist) =>{
  var keysplit = keylist.split(",");
  var jsonObj = {};
  for (i=0;i<keysplit.length;i++){
      jsonObj[keysplit[i]] = 0;
      console.log(keysplit[i]);
  }
  console.log(jsonObj);
  CartJS.updateItemQuantitiesById(jsonObj);
}

disabledOosAddOnVariant = (e) => {
  var lugWidthValue = getLugWidthValue();

  var addOnGrids = $('.jsc-product__addon-grid');
  addOnGrids.removeClass('addon-oos');
  addOnGrids.each(function() {
    var id = $(this).attr('data-id');
    var $modal = $('.jsc-addon-quick-view-modal[data-id="' + id + '"]');
    var addonJson = JSON.parse($(this).attr('data-addon'));
    var variants = addonJson.variants;
    var widthIndex = getVariantOptionIndex($(this), 'Width');
    var colorIndex = getVariantOptionIndex($(this), 'Color');

    var $swatchContainer = $($modal).find('.jsc-addon-modal-varopt');
    $($swatchContainer).find('.jsc-addon-swatch-opt').removeClass('sold-out');
    $($modal).find('.jsc-addon-submit').removeAttr('disabled');

    if(colorIndex != -1 && widthIndex != -1) { // add-on has color and width options
      // disable OOS color swatch
      var oosVariant = variants.filter(function(obj) {
        return obj['option' + widthIndex] == lugWidthValue && obj['available'] == false;
      });

      for(let variant of oosVariant) {
        var colorValue = variant['option' + colorIndex];
        $($swatchContainer).find('.jsc-addon-swatch-opt[data-value="' + colorValue + '"]').addClass('sold-out');
      }

      // select the 1st available color by default
      var $defaultColor = $($swatchContainer).find('.jsc-addon-swatch-opt:not(.sold-out):first');
      if($defaultColor.length <= 0) {
        $(this).addClass('addon-oos');
        $defaultColor = $($swatchContainer).find('.jsc-addon-swatch-opt:first');
      }
      $defaultColor.click();
    }
    else if(widthIndex != -1) { // add-on has width option only
      var oosVariant = variants.find(function(obj) {
        return obj['option' + widthIndex] == lugWidthValue && obj['available'] == false;
      });
      if(oosVariant != undefined) {
        $(this).addClass('addon-oos');
        $($modal).find('.jsc-addon-submit').attr('disabled', '');
      }
    }
  });
}

selectAddon = (e) => {
  var $modal = $(e).parents('.jsc-addon-quick-view-modal');
  var id = $modal.attr('data-id');
  var $installCheck = $($modal).find('.jsc-addon-modal-install input[type="checkbox"]');
  var $addonGrid = $('.jsc-product__addon-grid[data-id="' + id + '"]');
  var $addonIdInput = $($addonGrid).find('input[name="jsc-addon-selected-var"]');
  var addonJson = JSON.parse($($addonGrid).attr('data-addon'));
  var variants = addonJson.variants;
  var widthIndex = getVariantOptionIndex($($addonGrid), 'Width');
  var colorIndex = getVariantOptionIndex($($addonGrid), 'Color');
  var lugWidthValue = getLugWidthValue();
  var colorValue = $($modal).find('.jsc-addon-swatch-opt.active').attr('data-value');
  var selectedVariant;

  if(widthIndex != -1 && colorIndex != -1) {
    selectedVariant = variants.find(function(obj) {
      return obj['option' + widthIndex] == lugWidthValue && obj['option' + colorIndex] == colorValue;
    });
  }
  else if(widthIndex != -1){
    selectedVariant = variants.find(function(obj) {
      return obj['option' + widthIndex] == lugWidthValue;
    });
  }
  else {
    if(variants.length == 1 && variants[0].option1 == 'Default Title') {
      selectedVariant = variants[0];
    }
  }

  if($installCheck.length > 0) {
    if($installCheck.is(':checked')) {
      $addonIdInput.attr('data-install', true);
    }
    else {
      $addonIdInput.attr('data-install', false);
    }
  }
  
  $addonIdInput.val(selectedVariant.id);
  $addonGrid.addClass('addon-active');
  hideAddOnModal();
}

addonATC = (evt) => {
  var $addonWrap = $('.jsc-product__addon-wrap.jsc-addon-quick-view');
  if($addonWrap.length > 0) {
    var $activeAddonGrids = $('.jsc-product__addon-grid.addon-active');
    if($activeAddonGrids.length > 0) {
      $(evt).prop('disabled', true);

      var canATC = true;
      var jsonObj = [];
      var errorMsg;
      var $errorPopup = $('.jsc-pdp-error-popup');

      fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        var currentCartItems = data.items;

        // main product
        var mainProductVid = parseInt($('.jsc-var-pdp').val());
        var seconds = new Date().getTime() / 1000;
        var bundleID = mainProductVid + '-' + seconds;
        var mainProductInventoryInfo = $('.jsc-pdp-variant-inventory-info[data-vid="' + mainProductVid + '"]');

        // check main product inventory
        var mainProductInventoryQuantity = parseInt(mainProductInventoryInfo.data('inventory'));
        var isContinueSelling = mainProductInventoryInfo.data('is-continue');
        var productTitle = mainProductInventoryInfo.data('prod-title');
        var variantTitle = mainProductInventoryInfo.data('var-title');
        if(isContinueSelling === 'deny') {
          var mainProductInCart = currentCartItems.filter(function(obj) {
            return obj.id === mainProductVid;
          })
          var totalMainProductInCartQuantity = mainProductInCart.reduce(function(sum, obj) {
            return sum + obj.quantity;
          }, 0);
          var newMainProductInCartQuantity = totalMainProductInCartQuantity + 1;
          if(newMainProductInCartQuantity > mainProductInventoryQuantity) {
            canATC = false;
            errorMsg = `${productTitle} - ${variantTitle} has been added to your cart`;
          }
        }

        if(canATC == true) {
          // Main product obj
          var mainProd = {};
          var mainProp = {};
          mainProd['id'] = mainProductVid;
          mainProd['quantity'] = 1;
          mainProp['_MainBundle'] = 'Yes';
          mainProp['_BundleId'] = bundleID;
          if ($('#pdp-custom-delivery-strap').length > 0) {
            var cus_delivery_date = $('#pdp-custom-delivery-strap').find('input[name="properties[Estimated Delivery]"]').val();
            mainProp['Estimated Delivery'] = 'Week of ' + cus_delivery_date;;
          }

          // Add Pickup Only property if pickup message is visible
          var $pickupProp = $('.jsc-pickup-only-prop');
          if ($pickupProp.length > 0 && !$pickupProp.prop('disabled')) {
            mainProp['Location'] = $pickupProp.val();
          }
          
          mainProd['properties'] = mainProp;
          jsonObj.push(mainProd);
        }
        else {
          $errorPopup.find('.jsc-error-msg').text(errorMsg).addClass('jsc-product-error');
          $errorPopup.find('.jsc-addon-instruction').text('');
          $errorPopup.show();
        }

        // add-on products
        if(canATC == true) { // main product checking passed
          $activeAddonGrids.each(function() {
            var addonVid = parseInt($(this).find('input[name="jsc-addon-selected-var"]').val());
            var addonInstall = $(this).find('input[name="jsc-addon-selected-var"]').attr('data-install');
            var addOnInventoryInfo = $(this).find('.jsc-product__addon-inventory-info[data-vid="' + addonVid + '"]');
            var addonTitle = $(this).attr('data-title');
            var addOnDiscount = $(this).attr('data-addon-discount');

            // check add-on inventory
            var addOnInventoryQuantity = parseInt(addOnInventoryInfo.data('inventory'));
            var addOnIsContinueSelling = addOnInventoryInfo.data('is-continue');
            if(addOnIsContinueSelling === 'deny') {
              var addOnInCart = currentCartItems.filter(function(obj) {
                return obj.id === addonVid;
              })
              var totalAddonInCartQuantity = addOnInCart.reduce(function(sum, obj) {
                return sum + obj.quantity;
              }, 0);
              var newAddonInCartQuantity = totalAddonInCartQuantity + 1;
              if(newAddonInCartQuantity > addOnInventoryQuantity) {
                canATC = false;
                errorMsg = `<span class="jsc-popup-addon-title">${addonTitle}</span> for ${productTitle} - ${variantTitle} is out of stock.`;
              }
            }

            if(canATC == true) {
              var addOn = {};
              var addOnProp = {};
              addOn['id'] = addonVid;
              addOn['quantity'] = 1;
              addOnProp['_BundleId'] = bundleID;
              if (addOnDiscount > 0){
                addOnProp['_Discount Type'] = "percentage-off";
                addOnProp['_Discount Value'] = addOnDiscount;
              }
               
              if (addonInstall == 'true') {
                addOnProp['I want this to be installed'] = 'Yes';
              }

              addOn['properties'] = addOnProp;
              jsonObj.push(addOn);
            }
            else { // current add-on checking failed
              $errorPopup.find('.jsc-error-msg').html(errorMsg).removeClass('jsc-product-error');
              $errorPopup.find('.jsc-addon-instruction').text('Please select a different add-on.');
              $errorPopup.show();
              return false;
            }
          });
        }

        if(canATC == true) { // main product and add-ons checking passed, add item to cart
          CartJS.addItems(jsonObj,
          {
            // Define a success callback to display a success message.
            "success": function(data, textStatus, jqXHR) {
              console.log('success');
              $(document).on('cart.requestComplete', function(event, cart) {
                var cartCount = $('.thb-item-count');
                cartCount.text(cart.item_count);
              });
            },
            // Define an error callback to display an error message.
            "error": function(jqXHR, textStatus, errorThrown) {
              console.log("Error occur !", textStatus);
            }
          });
        }

        $(evt).prop('disabled', false);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  }
}

closeErrorPopup = (e) => {
  var popUpWrapper = $(e).parents('.jsc-pdp-error-popup');
  popUpWrapper.hide();
}
//End Addon PDP feature

// start: addon pdp feature old
addonFlickity2 = () =>{
  var $addonWrap = $('.jsc-product__addon-wrap.jsc-addon-inline-select');
  console.log('flickity', $addonWrap);
  if($addonWrap.length > 0) {
    $('.jsc-product__addon-wrap').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        groupCells: false,
        imagesLoaded: true,
        adaptiveHeight: false,
        prevNextButtons: true,
        wrapAround: false
    });
    $('.jsc-product__addon-wrap .jsc-product__addon-grid').css('height' , 'auto');
    var $height = 0;
    $('.jsc-product__addon-wrap .jsc-product__addon-grid').each(function(){
        if ($height <= $(this).outerHeight()) {
            $height = $(this).outerHeight();
        }
    });
    $('.jsc-product__addon-wrap .jsc-product__addon-grid').css('height' , $height + 'px');
    $( window ).on( "resize", function() {
      $('.jsc-product__addon-wrap .jsc-product__addon-grid').css('height' , 'auto');
      var $height = 0;
      $('.jsc-product__addon-wrap .jsc-product__addon-grid').each(function(){
          if ($height <= $(this).outerHeight()) {
              $height = $(this).outerHeight();
          }
      });
      $('.jsc-product__addon-wrap .jsc-product__addon-grid').css('height' , $height + 'px');
    });
  }
}

$('.jsc-addon-inline-select .jsc-product__addon-varopt .jsc-single-selector').change(function() {
  $('.jsc-addon-warning').text('');
  $(this).removeClass('border-red');

  $(this).closest('.jsc-addon-inline-select .jsc-product__addon-grid').addClass('addon-active');
});

checkedboxAddon = (evt) =>{
  if ($(evt).is(':checked')) {
    $('.addon-install').prop('checked',false);
    $(evt).prop('checked',true);
  }else{
    $(evt).prop('checked',false);
  }
}

disabledOosAddOnVariant2 = (e) => {
  var currentValue = $(e).val();
  if (!/\d/.test(currentValue)) {
    var addOnGrids = $('.jsc-product__addon-grid');
    addOnGrids.each(function(index, grid) {
      var addOnVariantContainer = $(grid).find('.jsc-product__addon-varopt');
      var addOnVariantDataInput = addOnVariantContainer.find("input[name='jsc-product__addon-varlist']"); // info of all variants of the add-on product
      var addOnOptionSize = addOnVariantDataInput.data('option-size');
      if(addOnOptionSize > 0) {
        $(grid).addClass('addon-oos');
      }
    });
    return; // Exit early if no number is found
  }

  var lugWidthValue = $(e).val().split('-')[1]; // current selected lug width
  var lugWidthFrontValue = $(e).val().split('-')[0];
  var index = lugWidthValue.indexOf("(");
  if (index !== -1) {
    lugWidthValue = lugWidthValue.substring(0, index);
    lugWidthValue = lugWidthValue.trim() + 'mm';
  } else {
    lugWidthValue = lugWidthValue + 'mm';
  }

  var index2 = lugWidthFrontValue.indexOf("(");
  if (index2 !== -1) {
    lugWidthFrontValue = lugWidthFrontValue.substring(0, index2);
    lugWidthFrontValue = lugWidthFrontValue.trim() + 'mm';
  } else {
    lugWidthFrontValue = lugWidthFrontValue + 'mm';
  }

  var addOnGrids = $('.jsc-product__addon-grid'); // all add-on grids
  addOnGrids.each(function(index, grid) {
    var isFrontLugWidthBased = $(grid).attr('lug-width-based');
    var addOnVariantContainer = $(grid).find('.jsc-product__addon-varopt');

    var addOnVariantDataInput = addOnVariantContainer.find("input[name='jsc-product__addon-varlist']"); // info of all variants of the add-on product
    var addOnVariantData = JSON.parse($(addOnVariantDataInput).val());
    var addOnOptionSize = addOnVariantDataInput.data('option-size');
    var isAvailable = addOnVariantDataInput.attr('is-available');

    if(addOnOptionSize === 0) {
      if(isAvailable === 'true' || isAvailable === true) {
        $(grid).removeClass('addon-oos');
      }
    }
    else if(addOnOptionSize === 1) {
      var relatedVariant = undefined;
      if (isFrontLugWidthBased != undefined) {
        relatedVariant = addOnVariantData.find(function(obj) { // get data of the specific variant
          return obj.option1 === lugWidthFrontValue;
        })
      }
      else {
        relatedVariant = addOnVariantData.find(function(obj) { // get data of the specific variant
          return obj.option1 === lugWidthValue;
        })
      }      

      if(relatedVariant === undefined) {
        $(grid).addClass('addon-oos');
        $(grid).find('.jsc-extra-label').text('not applicable');
      }
      else {
        $(grid).removeClass('addon-oos');
        $(grid).find('.jsc-extra-label').text('extras');

        if(relatedVariant.available === false) {
          $(grid).addClass('addon-oos');
          $(grid).find('.jsc-extra-label').text('sold out');
        }
        else {
          $(grid).removeClass('addon-oos');
          $(grid).find('.jsc-extra-label').text('extras');
        }
      }
    }
    else if(addOnOptionSize > 1) {
      var possibleVariants = undefined;
      if (isFrontLugWidthBased != undefined) {
         possibleVariants = addOnVariantData.filter(function(obj) { // variant with the matching lug width
          return obj.option2 === lugWidthFrontValue;
        });
      }
      else {
        possibleVariants = addOnVariantData.filter(function(obj) { // variant with the matching lug width
          return obj.option2 === lugWidthValue;
        });
      }

      if(possibleVariants.length <= 0) {
        $(grid).addClass('addon-oos');
        $(grid).find('.jsc-extra-label').text('not applicable');
      }
      else {
        $(grid).removeClass('addon-oos');
        $(grid).find('.jsc-extra-label').text('extras');

        var addOnSelectOptions = addOnVariantContainer.find('span:not(.hide) .jsc-single-selector').find('option'); // add-on variant value
        addOnSelectOptions.each(function(index, option) {
          var optValue = $(option).val();
          if(optValue !== "") {
            var relatedVariant = addOnVariantData.find(function(obj) { // get data of the specific variant
              return obj.option1 === optValue && obj.option2 === lugWidthValue;
            })
  
            if(relatedVariant !== undefined) {
              if(relatedVariant.available === false) {
                $(option).prop('disabled', true)
              }
              else {
                $(option).prop('disabled', false);
              }
            }
          }
        })
      }
    }
  });
}

// Helper function to handle option visibility on mobile (remove from DOM instead of just hiding)
handleOptionVisibility = ($option, isAvailable, isMobile) => {
  if (isMobile) {
    // On mobile, actually remove/add options from DOM for reliable hiding
    if (isAvailable) {
      // Ensure it's enabled and visible (if it's in the DOM)
      if ($option.parent().length) {
        $option.prop('disabled', false)
                .removeAttr('style')
                .removeAttr('hidden')
                .removeClass('jsc-hidden-option');
      }
    } else {
      // If option should be unavailable, remove it from DOM completely
      if ($option.parent().length) {
        // Store reference to the select element
        var $select = $option.parent();
        // Store the option in the select's data for potential restoration
        var storedOptions = $select.data('jsc-stored-options') || [];
        // Check if this option is already stored
        var alreadyStored = storedOptions.some(function(stored) {
          return stored.val() === $option.val();
        });
        if (!alreadyStored) {
          storedOptions.push($option.clone(true));
          $select.data('jsc-stored-options', storedOptions);
        }
        // Remove from DOM
        $option.remove();
      }
    }
  } else {
    // On desktop, use CSS/attributes for hiding
    if (isAvailable) {
      $option.prop('disabled', false)
              .removeAttr('style')
              .removeAttr('hidden')
              .removeClass('jsc-hidden-option');
    } else {
      $option.prop('disabled', true)
              .css({'display': 'none', 'visibility': 'hidden'})
              .attr('hidden', 'hidden')
              .addClass('jsc-hidden-option');
    }
  }
  return $option;
}

// Function to hide/show width fieldset based on selected colour
toggleWidthFieldsetByColour = (e) => {
  var $fieldset = $(e).closest('fieldset');
  var fieldsetHandle = $fieldset.attr('data-handle') || '';
  var fieldsetIndex = $fieldset.attr('data-index') || '';
  var elementIndex = parseInt($(e).attr('index')) || parseInt(fieldsetIndex.replace('option', '')) || 0;
  var fieldsetLabel = $fieldset.find('.form__label').text().toLowerCase();
  
  // Check if this is a colour field by handle, index, or label
  var isColourField = fieldsetHandle.includes('colour') || fieldsetHandle.includes('color') || 
                      fieldsetLabel.includes('colour') || fieldsetLabel.includes('color') || 
                      elementIndex === 1;
  
  if (isColourField) {
    // Use setTimeout to ensure DOM is updated for radio buttons
    setTimeout(function() {
      var selectedColour = $(e).val() || $(e).attr('value');
      // For radio buttons, get the checked value from the fieldset
      if (!selectedColour && $(e).is('input[type="radio"]')) {
        selectedColour = $fieldset.find('input[type="radio"]:checked').val();
      }
      
      var $widthFieldset = $('.jsc-main_pdp_var_field fieldset[data-handle="width"]');
      
      if ($widthFieldset.length === 0) {
        // Try alternative selectors in case handle is different
        $widthFieldset = $('.jsc-main_pdp_var_field fieldset').filter(function() {
          var handle = $(this).attr('data-handle') || '';
          var label = $(this).find('.form__label').text().toLowerCase();
          return handle.includes('width') || label.includes('width');
        });
      }
      
      if ($widthFieldset.length > 0 && selectedColour) {
      // Get variant data from the JSON script tag
      var $variantScript = $('.jsc-main_pdp_var_field').closest('variant-selects').find('script[type="application/json"]');
      var variants = [];
      
      if ($variantScript.length > 0) {
        try {
          variants = JSON.parse($variantScript.html());
        } catch(e) {
          console.error('Error parsing variant JSON:', e);
        }
      }
      
      // If no JSON found, use variant info from hidden inputs
      if (variants.length === 0) {
        var $variantInfo = $('.jsc-pdp-variant-info-container').find('.jsc-variant-info');
        $variantInfo.each(function() {
          if ($(this).attr('data-option1') === selectedColour) {
            variants.push({
              option1: $(this).attr('data-option1'),
              option2: $(this).attr('data-option2'),
              option3: $(this).attr('data-option3'),
              available: $(this).attr('data-is-hidden') !== 'true'
            });
          }
        });
      } else {
        // Filter variants by selected colour
        variants = variants.filter(function(variant) {
          return variant.option1 === selectedColour;
        });
      }
      
      // Get unique width values available for this colour
      var availableWidths = [];
      variants.forEach(function(variant) {
        if (variant.option2 && availableWidths.indexOf(variant.option2) === -1) {
          availableWidths.push(variant.option2);
        }
      });
      
      // Show/hide width fieldset based on availability
      if (availableWidths.length > 0) {
        $widthFieldset.removeClass('is-hidden').show();
        
        // Filter width options to only show available widths
        var $widthSelect = $widthFieldset.find('select');
        var currentWidth = $widthSelect.val();
        var needsReset = false;
        
        // If colour changed and current width is not valid for this colour, pick a valid width
        if (currentWidth && availableWidths.indexOf(currentWidth) === -1) {
          needsReset = true;
        }
        // Do not auto-select width when only colour is chosen (consistent across all products).
        
        var firstAvailableWidth = null;
        var isMobile = isMobileDevice();
        
        // On mobile, first restore any previously stored options that should now be available
        if (isMobile) {
          var $storedOptions = $widthSelect.data('jsc-stored-options') || [];
          var remainingStored = [];
          $storedOptions.forEach(function($storedOption) {
            var storedValue = $storedOption.val();
            if (availableWidths.indexOf(storedValue) !== -1) {
              // This option should be available, restore it
              $widthSelect.append($storedOption);
            } else {
              // Keep it stored for later
              remainingStored.push($storedOption);
            }
          });
          $widthSelect.data('jsc-stored-options', remainingStored);
        }
        
        // Now process all current options in the DOM
        $widthSelect.find('option').each(function() {
          var $option = $(this);
          var optionValue = $option.val();
          
          if (optionValue === '' || optionValue === null) {
            // Keep the placeholder option enabled but never selected
            handleOptionVisibility($option, true, isMobile);
            $option.removeAttr('selected').prop('selected', false);
            return;
          }
          
          var isAvailable = availableWidths.indexOf(optionValue) !== -1;
          handleOptionVisibility($option, isAvailable, isMobile);
          
          // Only process if option is still in DOM (not removed on mobile)
          if ($option.parent().length) {
            if (isAvailable) {
              // First valid width in DOM order (used only when needsReset picks a fallback after colour change)
              if (firstAvailableWidth === null) {
                firstAvailableWidth = optionValue;
              }
              // Only keep selected if it was the current selection and we're not resetting
              if (optionValue === currentWidth && !needsReset) {
                $option.prop('selected', true);
              } else {
                $option.removeAttr('selected').prop('selected', false);
              }
            } else {
              // Remove selected attribute from disabled/hidden options
              $option.removeAttr('selected').prop('selected', false);
            }
          }
        });
        
        // If colour change invalidated width, jump to first valid width for this colour only
        if (needsReset && firstAvailableWidth) {
          $widthSelect.val(firstAvailableWidth).trigger('change');
        } else if (!needsReset && (!currentWidth || currentWidth === '')) {
          $widthSelect.val('').trigger('change');
        }
      } else {
        // Hide width fieldset if no widths available
        $widthFieldset.addClass('is-hidden').hide();
        var $widthSelect = $widthFieldset.find('select');
        // Clear all selected attributes and select placeholder
        $widthSelect.find('option').removeAttr('selected').prop('selected', false);
        $widthSelect.find('option[value=""]').prop('selected', true);
        $widthSelect.val('').trigger('change');
      }
      } else if ($widthFieldset.length > 0 && !selectedColour) {
        // Show all width options when no colour is selected
        $widthFieldset.removeClass('is-hidden').show();
        var $widthSelect = $widthFieldset.find('select');
        $widthSelect.find('option').prop('disabled', false).show();
      }
    }, 100);
  }
}

metaDisabledOosAddOnVariant = (e) => {
  var index = parseInt($(e).attr('index'));
  if(index === 1) {
    var currentValue = $(e).val();
    var $variantInfo = $('.jsc-pdp-variant-info-container').find('.jsc-variant-info[data-option1="' + currentValue + '"]:first');
    if ($variantInfo.length > 0 && $variantInfo.attr('lug-width') != '') {
      var lugWidth = $variantInfo.attr('lug-width');
      var lugWidthValue = lugWidth.split('-')[1];
      var lugWidthFrontValue = lugWidth.split('-')[0];
      var index = lugWidthValue.indexOf("(");
      if (index !== -1) {
        lugWidthValue = lugWidthValue.substring(0, index);
        lugWidthValue = lugWidthValue.trim() + 'mm';
      } else {
        lugWidthValue = lugWidthValue + 'mm';
      }

      var index2 = lugWidthFrontValue.indexOf("(");
      if (index2 !== -1) {
        lugWidthFrontValue = lugWidthFrontValue.substring(0, index2);
        lugWidthFrontValue = lugWidthFrontValue.trim() + 'mm';
      } else {
        lugWidthFrontValue = lugWidthFrontValue + 'mm';
      }

      var addOnGrids = $('.jsc-product__addon-grid'); // all add-on grids
      addOnGrids.each(function(index, grid) {
        var isFrontLugWidthBased = $(grid).attr('lug-width-based');
        var addOnVariantContainer = $(grid).find('.jsc-product__addon-varopt');

        var addOnVariantDataInput = addOnVariantContainer.find("input[name='jsc-product__addon-varlist']"); // info of all variants of the add-on product
        var addOnVariantData = JSON.parse($(addOnVariantDataInput).val());
        var addOnOptionSize = addOnVariantDataInput.data('option-size');
        var isAvailable = addOnVariantDataInput.attr('is-available');

        if(addOnOptionSize === 0) {
          if(isAvailable === 'true' || isAvailable === true) {
            $(grid).removeClass('addon-oos');
          }
        }
        else if(addOnOptionSize === 1) {
          var relatedVariant = undefined;
          if (isFrontLugWidthBased != undefined) {
            relatedVariant = addOnVariantData.find(function(obj) { // get data of the specific variant
              return obj.option1 === lugWidthFrontValue;
            })
          }
          else {
            relatedVariant = addOnVariantData.find(function(obj) { // get data of the specific variant
              return obj.option1 === lugWidthValue;
            })
          }

          if(relatedVariant === undefined) {
            $(grid).addClass('addon-oos');
            $(grid).find('.jsc-extra-label').text('not applicable');
          }
          else {
            $(grid).removeClass('addon-oos');
            $(grid).find('.jsc-extra-label').text('extras');

            if(relatedVariant.available === false) {
              $(grid).addClass('addon-oos');
              $(grid).find('.jsc-extra-label').text('sold out');
            }
            else {
              $(grid).removeClass('addon-oos');
              $(grid).find('.jsc-extra-label').text('extras');
            }
          }
        }
        else if(addOnOptionSize > 1) {
          var possibleVariants = undefined;
          if (isFrontLugWidthBased != undefined) {
            possibleVariants = addOnVariantData.filter(function(obj) { // variant with the matching lug width
              return obj.option2 === lugWidthFrontValue;
            });
          }
          else {
            possibleVariants = addOnVariantData.filter(function(obj) { // variant with the matching lug width
              return obj.option2 === lugWidthValue;
            });
          }

          if(possibleVariants.length <= 0) {
            $(grid).addClass('addon-oos');
            $(grid).find('.jsc-extra-label').text('not applicable');
          }
          else {
            $(grid).removeClass('addon-oos');
            $(grid).find('.jsc-extra-label').text('extras');

            var addOnSelectOptions = addOnVariantContainer.find('span:not(.hide) .jsc-single-selector').find('option'); // add-on variant value
            addOnSelectOptions.each(function(index, option) {
              var optValue = $(option).val();
              if(optValue !== "") {
                var relatedVariant = addOnVariantData.find(function(obj) { // get data of the specific variant
                  return obj.option1 === optValue && obj.option2 === lugWidthValue;
                })
      
                if(relatedVariant !== undefined) {
                  if(relatedVariant.available === false) {
                    $(option).prop('disabled', true)
                  }
                  else {
                    $(option).prop('disabled', false);
                  }
                }
              }
            })
          }
        }
      });
    }
  }
}

// Helper function to detect mobile devices (iOS and Android)
isMobileDevice = () => {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // Check for iOS devices
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  // Check for Android devices
  var isAndroid = /android/i.test(userAgent);
  // Check for mobile screen width
  var isMobileWidth = window.innerWidth <= 768;
  return isIOS || isAndroid || isMobileWidth;
}

// Flag to track if mobile event listeners have been initialized
var mobileWidthFieldsetListenersInitialized = false;

// Initialize mobile event listeners for width fieldset visibility (only once)
initMobileWidthFieldsetListeners = () => {
  if (mobileWidthFieldsetListenersInitialized || !isMobileDevice()) {
    return;
  }
  
  mobileWidthFieldsetListenersInitialized = true;
  
  // Listen for changes on color radio buttons/swatches
  $(document).on('change touchstart click', '.jsc-main_pdp_var_field fieldset input[type="radio"]', function() {
    var $fieldset = $(this).closest('fieldset');
    var handle = $fieldset.attr('data-handle') || '';
    var label = $fieldset.find('.form__label').text().toLowerCase();
    var isColourField = handle.includes('colour') || handle.includes('color') || label.includes('colour') || label.includes('color');
    
    if (isColourField) {
      // Small delay to ensure the radio button is properly checked
      setTimeout(function() {
        initWidthFieldsetByColour();
      }, 100);
    }
  });
  
  // Also listen for select changes on mobile
  $(document).on('change', '.jsc-main_pdp_var_field fieldset select', function() {
    var $fieldset = $(this).closest('fieldset');
    var handle = $fieldset.attr('data-handle') || '';
    var label = $fieldset.find('.form__label').text().toLowerCase();
    var isColourField = handle.includes('colour') || handle.includes('color') || label.includes('colour') || label.includes('color');
    
    if (isColourField) {
      toggleWidthFieldsetByColour(this);
    }
  });
}

// Initialize width fieldset visibility on page load
initWidthFieldsetByColour = () => {
  var $colourSelect = $('.jsc-main_pdp_var_field fieldset').filter(function() {
    var handle = $(this).attr('data-handle') || '';
    var label = $(this).find('.form__label').text().toLowerCase();
    return handle.includes('colour') || handle.includes('color') || label.includes('colour') || label.includes('color');
  }).find('select');
  
  // Also check for color swatches (radio buttons)
  var $colourRadios = $('.jsc-main_pdp_var_field fieldset').filter(function() {
    var handle = $(this).attr('data-handle') || '';
    var label = $(this).find('.form__label').text().toLowerCase();
    return handle.includes('colour') || handle.includes('color') || label.includes('colour') || label.includes('color');
  }).find('input[type="radio"]:checked');
  
  // On mobile, also check for any checked radio buttons (not just :checked selector which might not work on initial load)
  if (isMobileDevice() && $colourRadios.length === 0) {
    var $colourFieldset = $('.jsc-main_pdp_var_field fieldset').filter(function() {
      var handle = $(this).attr('data-handle') || '';
      var label = $(this).find('.form__label').text().toLowerCase();
      return handle.includes('colour') || handle.includes('color') || label.includes('colour') || label.includes('color');
    });
    $colourRadios = $colourFieldset.find('input[type="radio"][checked]');
    // If still no checked radio, check for the first visible/active one
    if ($colourRadios.length === 0) {
      $colourRadios = $colourFieldset.find('input[type="radio"]').filter(function() {
        return $(this).is(':visible') && ($(this).parent().hasClass('active') || $(this).closest('label').hasClass('active'));
      }).first();
    }
  }
  
  if ($colourSelect.length > 0 && $colourSelect.val()) {
    toggleWidthFieldsetByColour($colourSelect[0]);
  } else if ($colourRadios.length > 0) {
    // Handle color swatch selection
    var selectedColour = $colourRadios.val() || $colourRadios.attr('value');
    var $widthFieldset = $('.jsc-main_pdp_var_field fieldset[data-handle="width"]');
    
    if ($widthFieldset.length === 0) {
      $widthFieldset = $('.jsc-main_pdp_var_field fieldset').filter(function() {
        var handle = $(this).attr('data-handle') || '';
        var label = $(this).find('.form__label').text().toLowerCase();
        return handle.includes('width') || label.includes('width');
      });
    }
    
    if ($widthFieldset.length > 0 && selectedColour) {
      var $variantScript = $('.jsc-main_pdp_var_field').closest('variant-selects').find('script[type="application/json"]');
      var variants = [];
      
      if ($variantScript.length > 0) {
        try {
          variants = JSON.parse($variantScript.html());
        } catch(e) {
          console.error('Error parsing variant JSON:', e);
        }
      }
      
      if (variants.length === 0) {
        var $variantInfo = $('.jsc-pdp-variant-info-container').find('.jsc-variant-info');
        $variantInfo.each(function() {
          if ($(this).attr('data-option1') === selectedColour) {
            variants.push({
              option1: $(this).attr('data-option1'),
              option2: $(this).attr('data-option2'),
              option3: $(this).attr('data-option3'),
              available: $(this).attr('data-is-hidden') !== 'true'
            });
          }
        });
      } else {
        variants = variants.filter(function(variant) {
          return variant.option1 === selectedColour;
        });
      }
      
      var availableWidths = [];
      variants.forEach(function(variant) {
        if (variant.option2 && availableWidths.indexOf(variant.option2) === -1) {
          availableWidths.push(variant.option2);
        }
      });
      
      if (availableWidths.length > 0) {
        $widthFieldset.removeClass('is-hidden').show();
        // Show valid width options for this colour; do not auto-select second option (same as colour-change path).
        var $widthSelect = $widthFieldset.find('select');
        if ($widthSelect.length > 0 && availableWidths.length > 0) {
          var currentWidth = $widthSelect.val();
          var isMobile = isMobileDevice();
          
          // On mobile, first restore any previously stored options that should now be available
          if (isMobile) {
            var $storedOptions = $widthSelect.data('jsc-stored-options') || [];
            var remainingStored = [];
            $storedOptions.forEach(function($storedOption) {
              var storedValue = $storedOption.val();
              if (availableWidths.indexOf(storedValue) !== -1) {
                // This option should be available, restore it
                $widthSelect.append($storedOption);
              } else {
                // Keep it stored for later
                remainingStored.push($storedOption);
              }
            });
            $widthSelect.data('jsc-stored-options', remainingStored);
          }
          
          // Hide/disable unavailable widths; keep current width if already valid (e.g. ?variant=).
          $widthSelect.find('option').each(function() {
            var $option = $(this);
            var optionValue = $option.val();
            
            if (optionValue === '' || optionValue === null) {
              // Keep the placeholder option enabled but never selected
              handleOptionVisibility($option, true, isMobile);
              $option.removeAttr('selected').prop('selected', false);
              return;
            }
            
            var isAvailable = availableWidths.indexOf(optionValue) !== -1;
            handleOptionVisibility($option, isAvailable, isMobile);
            
            // Only process if option is still in DOM (not removed on mobile)
            if ($option.parent().length) {
              if (isAvailable) {
                if (optionValue === currentWidth && currentWidth) {
                  $option.prop('selected', true);
                  $widthSelect.val(optionValue);
                } else {
                  $option.removeAttr('selected').prop('selected', false);
                }
              } else {
                $option.removeAttr('selected').prop('selected', false);
              }
            }
          });
          
          if (!currentWidth || currentWidth === '') {
            $widthSelect.val('').trigger('change');
          }
        }
      } else {
        // Hide width fieldset if no widths available
        $widthFieldset.addClass('is-hidden').hide();
        var $widthSelect = $widthFieldset.find('select');
        if ($widthSelect.length > 0) {
          var isMobile = isMobileDevice();
          // Also disable and hide all options except placeholder
          $widthSelect.find('option').each(function() {
            var $option = $(this);
            var optionValue = $option.val();
            if (optionValue === '' || optionValue === null) {
              handleOptionVisibility($option, true, isMobile);
            } else {
              handleOptionVisibility($option, false, isMobile);
            }
            // Only process if option is still in DOM (not removed on mobile)
            if ($option.parent().length) {
              $option.removeAttr('selected').prop('selected', false);
            }
          });
          // Clear selection and select placeholder
          if ($widthSelect.find('option[value=""]').length) {
            $widthSelect.find('option[value=""]').prop('selected', true);
            $widthSelect.val('').trigger('change');
          }
        }
      }
    } else if ($widthFieldset.length > 0 && !selectedColour) {
      // On mobile, if no colour is selected, hide width fieldset
      if (isMobileDevice()) {
        $widthFieldset.addClass('is-hidden').hide();
      }
    }
  }
  
  // Initialize mobile event listeners (only once)
  initMobileWidthFieldsetListeners();
}

onLoadDisabledOosAddOnVariant = () => {
  var $addonWrap = $('.jsc-product__addon-wrap.jsc-addon-inline-select');
  console.log('onLoadDisabledOosAddOnVariant', $addonWrap.length);
  if($addonWrap.length > 0) {
    console.log('has addon wrap');
    var selectedVariantId = $('.jsc-var-pdp').val();
    if(selectedVariantId !== "" && selectedVariantId !== undefined) {
      console.log('has selected variant id');
      var $variantInfo = $('.jsc-pdp-variant-info-container').find('.jsc-variant-info[data-vid="' + selectedVariantId + '"]');
      if ($variantInfo.length > 0 && $variantInfo.attr('lug-width') != '') {
        var lugWidthSelector = $('.jsc-main_pdp_var_field').find('select[index="1"]');
        metaDisabledOosAddOnVariant(lugWidthSelector)
      }
      else {
        var lugWidthSelector = $('.jsc-main_pdp_var_field .lug-width-select').find('select');
        disabledOosAddOnVariant2(lugWidthSelector)
      }
    }
    else {
      console.log('no selected variant id');
      var addOnGrids = $('.jsc-product__addon-grid');
      addOnGrids.each(function(index, grid) {
        var addOnVariantContainer = $(grid).find('.jsc-product__addon-varopt');
        var addOnVariantDataInput = addOnVariantContainer.find("input[name='jsc-product__addon-varlist']"); // info of all variants of the add-on product
        var addOnOptionSize = addOnVariantDataInput.data('option-size');
        if(addOnOptionSize > 0) {
          $(grid).addClass('addon-oos');
        }
      });
    }
  }
}

addonATC2 = (evt) => {
  var $addonWrap = $('.jsc-product__addon-wrap.jsc-addon-inline-select');
  var $buckleOption = $('.jsc-buckle-option__wrap');
  if($addonWrap.length > 0 || $buckleOption.length > 0) {
    if ($('.jsc-product__addon-grid.addon-active').length > 0 || $('.jsc-fake-variant').length > 0 || $('.jsc-buckle-option__variant.active').length > 0) {
      $(evt).prop('disabled', true); // to disable default ATC behavior

      var addonallcheck = true;
      var canATC = true;
      var prodErrorMsgText = '';
      var addOnErrorMsgText = '';
      var currentCartItems;

      // Check if backorder checkbox is visible and ticked
      var $backorderWrapper = $('.jsc-backorder-checkbox-wrapper');
      if ($backorderWrapper.length > 0 && !$backorderWrapper.hasClass('hide') && $backorderWrapper.is(':visible')) {
        var $backorderCheckbox = $backorderWrapper.find('.jsc-backorder-checkbox');
        if ($backorderCheckbox.length > 0 && !$backorderCheckbox.is(':checked')) {
          canATC = false;
          prodErrorMsgText = 'Please acknowledge the backorder by checking the checkbox before adding to cart.';
          
          // Check if clicked from sticky add to cart
          var isSticky = $(evt).closest('.product-add-to-cart-sticky').length > 0 || $(evt).attr('id') === 'AddToCartSticky';
          if (isSticky && $backorderWrapper.offset()) {
            // Scroll to checkbox when clicked from sticky
            $('html, body').animate({
              scrollTop: $backorderWrapper.offset().top - 100
            }, 300);
          }
        }
      }

      fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
      })
      .then(response => {
        // Parse the response as JSON
        return response.json();
      })
      .then(data => {
        currentCartItems = data.items
      })
      .catch((error) => {
        console.error('Error:', error);
      });

      var seconds = new Date().getTime() / 1000;
      var jsonObj = [];
      var mainProd = {};
      var mainProp = {};
      var $activeBuckleOption =  $('.jsc-buckle-option__wrap .jsc-buckle-option__tab-content-wrap.active');
      var $activeBuckleVariant = $activeBuckleOption.find('.jsc-buckle-option__variant.active');
      var $watchModelProp = $('input[name="properties[Watch Model]"]');
      var $shellProductProp = $('input[name="properties[_RelatedProduct]"]');

      var mainProductVid = parseInt($('.jsc-var-pdp').val()); // main product variant id
      var mainProductInventoryInfo = $('.jsc-pdp-variant-inventory-info[data-vid="' + mainProductVid + '"]');
      var bundleID = mainProductVid + '-' + seconds;
      // Main product obj
      mainProd['id'] = mainProductVid;
      mainProd['quantity'] = 1;
      if (($('.jsc-buckle-option__variant.active').length > 0 && !$activeBuckleVariant.hasClass('included')) || ($('.jsc-product__addon-grid.addon-active').length > 0 || $('.jsc-fake-variant').length > 0)) {
        mainProp['_MainBundle'] = 'Yes';
        mainProp['_BundleId'] = bundleID;
      }

      if ($('#pdp-custom-delivery-strap').length > 0) {
        var cus_delivery_date = $('#pdp-custom-delivery-strap').find('input[name="properties[Estimated Delivery]"]').val();
        mainProp['Estimated Delivery'] = 'Week of ' + cus_delivery_date;
      }

      if ($activeBuckleVariant.length > 0 && $activeBuckleOption.length > 0) {
        var buckleTitle = $activeBuckleOption.attr('data-title');
        var buckleVariantTitle = $activeBuckleVariant.attr('variant-title');
        if (buckleTitle.toLowerCase().includes('buckle')) {
          var buckleOption = buckleTitle + ' - ' + buckleVariantTitle;
          mainProp['Buckle Option'] = buckleOption;
          if (!$activeBuckleVariant.hasClass('included')) {
            mainProp['_BuckleSwap'] = 'Buckle';
          }
        }
      }

      if ($watchModelProp.length > 0) {
        mainProp['Watch Model'] = $watchModelProp.val();
      }

      if ($shellProductProp.length > 0) {
        mainProp['_RelatedProduct'] = $shellProductProp.val();
      }

      // Add Backorder property if checkbox is checked and wrapper is visible
      var $backorderWrapper = $('.jsc-backorder-checkbox-wrapper');
      var $backorderCheckbox = $('.jsc-backorder-checkbox');
      if ($backorderWrapper.length > 0 && !$backorderWrapper.hasClass('hide') && $backorderCheckbox.length > 0 && $backorderCheckbox.is(':checked')) {
      console.log('Backorder checkbox is checked');
        var backorderText = $backorderWrapper.attr('data-backorder-text');
        if (backorderText) {
          mainProp['Backorder'] = backorderText;
        }
      }

      // Add Pickup Only property if pickup message is visible
      var $pickupProp = $('.jsc-pickup-only-prop');
      if ($pickupProp.length > 0 && !$pickupProp.prop('disabled')) {
        mainProp['Location'] = $pickupProp.val();
      }

      mainProd['properties'] = mainProp;
      jsonObj.push(mainProd);

      // check main product inventory
      var mainProductInventoryQuantity = parseInt(mainProductInventoryInfo.data('inventory'));
      var isContinueSelling = mainProductInventoryInfo.data('is-continue');
      var productTitle = mainProductInventoryInfo.data('prod-title');
      var variantTitle = mainProductInventoryInfo.data('var-title');
      if(isContinueSelling === 'deny') {
        setTimeout(() => {
          var mainProductInCart = currentCartItems.filter(function(obj) {
            return obj.id === mainProductVid;
          })
          var totalMainProductInCartQuantity = mainProductInCart.reduce(function(sum, obj) {
            return sum + obj.quantity;
          }, 0);
          var newMainProductInCartQuantity = totalMainProductInCartQuantity + 1;
          if(newMainProductInCartQuantity > mainProductInventoryQuantity) {
            canATC = false;
            prodErrorMsgText = productTitle + ' - ' + variantTitle + ' has been added to your cart.';
          }
        }, 600);
      }

      if($('.jsc-main_pdp_var_field .lug-width-select').find('select').length > 0) {
        var lugWidthSelector = $('.jsc-main_pdp_var_field .lug-width-select').find('select');
        var lugWidthValue = lugWidthSelector.val().split('-')[1]; // main product selected lug width value
        var lugWidthFrontValue = lugWidthSelector.val().split('-')[0];
        var index = lugWidthValue.indexOf("(");
        if (index !== -1) {
          lugWidthValue = lugWidthValue.substring(0, index);
          lugWidthValue = lugWidthValue.trim() + 'mm';
        } else {
          lugWidthValue = lugWidthValue + 'mm';
        }

        var index2 = lugWidthFrontValue.indexOf("(");
        if (index2 !== -1) {
          lugWidthFrontValue = lugWidthFrontValue.substring(0, index2);
          lugWidthFrontValue = lugWidthFrontValue.trim() + 'mm';
        } else {
          lugWidthFrontValue = lugWidthFrontValue + 'mm';
        }
      }
      else if ($('.jsc-main_pdp_var_field').find('select[index="1"]').length > 0) {
        var lugWidthSelector = $('.jsc-main_pdp_var_field').find('select[index="1"]');
        var currentValue = lugWidthSelector.val();
        var $variantInfo = $('.jsc-pdp-variant-info-container').find('.jsc-variant-info[data-option1="' + currentValue + '"]:first');
        if ($variantInfo.length > 0 && $variantInfo.attr('lug-width') != '') {
          var lugWidth = $variantInfo.attr('lug-width');
          var lugWidthValue = lugWidth.split('-')[1];
          var lugWidthFrontValue = lugWidth.split('-')[0];
          var index = lugWidthValue.indexOf("(");
          if (index !== -1) {
            lugWidthValue = lugWidthValue.substring(0, index);
            lugWidthValue = lugWidthValue.trim() + 'mm';
          } else {
            lugWidthValue = lugWidthValue + 'mm';
          }
  
          var index2 = lugWidthFrontValue.indexOf("(");
          if (index2 !== -1) {
            lugWidthFrontValue = lugWidthFrontValue.substring(0, index2);
            lugWidthFrontValue = lugWidthFrontValue.trim() + 'mm';
          } else {
            lugWidthFrontValue = lugWidthFrontValue + 'mm';
          }
        }
      }

      var activeAddOnGrids = $('.jsc-product__addon-grid.addon-active'); // selected add-ons
      activeAddOnGrids.each(function(index, grid) {
        var addOnVariantContainer = $(grid).find('.jsc-product__addon-varopt');
        var installCheckbox = $(grid).find('.addon-install'); // install option checkbox
        var isFrontLugWidthBased = $(grid).attr('lug-width-based');
        var addOnDiscount = $(grid).attr('data-addon-discount');

        var addOnSelectedVariant = addOnVariantContainer.find('span:not(.hide) .jsc-single-selector').val(); // add-on variant value
        if(addOnSelectedVariant === "") {
          addonallcheck = false;
        }

        var addOnVariantDataInput = addOnVariantContainer.find("input[name='jsc-product__addon-varlist']"); // info of all variants of the add-on product
        var addOnOptionSize = addOnVariantDataInput.data('option-size');
        var addOnVariantData = JSON.parse($(addOnVariantDataInput).val());

        if(addOnOptionSize === 0) { // add-on without variant
          var variant = addOnVariantData[0];
          var addOnTitle = variant.name;
          var addOn = {};
          var addOnProp = {};
          addOn['id'] = variant.id;
          addOn['quantity'] = 1;
          addOnProp['_BundleId'] = bundleID;

          if (addOnDiscount > 0){
            addOnProp['_Discount Type'] = "percentage-off";
            addOnProp['_Discount Value'] = addOnDiscount;
          }

          if(installCheckbox.length > 0) {
            if ($(installCheckbox).is(':checked')) {
              addOnProp['I want this to be installed'] = 'Yes';
            }
          }

          addOn['properties'] = addOnProp;
          jsonObj.push(addOn);

          // check add-on inventory
          var addOnInventoryInfo = addOnVariantContainer.find('.jsc-product__addon-inventory-info[data-vid="' + variant.id + '"]');
          var addOnInventoryQuantity = parseInt(addOnInventoryInfo.data('inventory'));
          var addOnIsContinueSelling = addOnInventoryInfo.data('is-continue');
          if(addOnIsContinueSelling === 'deny') {
            setTimeout(() => {
              var addOnInCart = currentCartItems.filter(function(obj) {
                return obj.id === variant.id;
              })
              var totalAddOnInCartQuantity = addOnInCart.reduce(function(sum, obj) {
                return sum + obj.quantity;
              }, 0);
              var newAddOnInCartQuantity = totalAddOnInCartQuantity + 1;
              if(newAddOnInCartQuantity > addOnInventoryQuantity) {
                canATC = false;
                addOnErrorMsgText = '<span class="jsc-popup-addon-title">' + addOnTitle + '</span> for ' + productTitle + ' - ' + variantTitle + ' is out of stock.';
              }
            }, 600);
          }
        }
        else if(addOnOptionSize === 1) { // add-on with 1 variant option
          var variant = null;
          if (isFrontLugWidthBased != undefined) {
            variant = addOnVariantData.find(function(obj) { // get data of the specific variant
              return obj.option1 === lugWidthFrontValue;
            })
          }
          else {
            variant = addOnVariantData.find(function(obj) { // get data of the specific variant
              return obj.option1 === lugWidthValue;
            })
          }

          var addOnTitle = variant.name.split(" - ")[0];
          var addOn = {};
          var addOnProp = {};
          addOn['id'] = variant.id;
          addOn['quantity'] = 1;
          addOnProp['_BundleId'] = bundleID;

          if (addOnDiscount > 0){
            addOnProp['_Discount Type'] = "percentage-off";
            addOnProp['_Discount Value'] = addOnDiscount;
          }

          if(installCheckbox.length > 0) {
            if ($(installCheckbox).is(':checked')) {
              addOnProp['I want this to be installed'] = 'Yes';
            }
          }

          addOn['properties'] = addOnProp;
          jsonObj.push(addOn);

          // check add-on inventory
          var addOnInventoryInfo = addOnVariantContainer.find('.jsc-product__addon-inventory-info[data-vid="' + variant.id + '"]');
          var addOnInventoryQuantity = parseInt(addOnInventoryInfo.data('inventory'));
          var addOnIsContinueSelling = addOnInventoryInfo.data('is-continue');
          if(addOnIsContinueSelling === 'deny') {
            setTimeout(() => {
              var addOnInCart = currentCartItems.filter(function(obj) {
                return obj.id === variant.id;
              })
              var totalAddOnInCartQuantity = addOnInCart.reduce(function(sum, obj) {
                return sum + obj.quantity;
              }, 0);
              var newAddOnInCartQuantity = totalAddOnInCartQuantity + 1;
              if(newAddOnInCartQuantity > addOnInventoryQuantity) {
                canATC = false;
                addOnErrorMsgText = '<span class="jsc-popup-addon-title">' + addOnTitle + '</span> for ' + productTitle + ' - ' + variantTitle + ' is out of stock.';
              }
            }, 600);
          }
        }
        else { // add-on with variant
          for(variant of addOnVariantData) {
            if (isFrontLugWidthBased != undefined) {
              if(variant.option1 === addOnSelectedVariant && variant.option2 === lugWidthFrontValue && variant.available === true) {
                var addOnTitle = variant.name.split(" - ")[0];
                var addOn = {};
                var addOnProp = {};
                addOn['id'] = variant.id;
                addOn['quantity'] = 1;
                addOnProp['_BundleId'] = bundleID;
                if (addOnDiscount > 0){
                  addOnProp['_Discount Type'] = "percentage-off";
                  addOnProp['_Discount Value'] = addOnDiscount;
                }

                if(installCheckbox.length > 0) {
                  if ($(installCheckbox).is(':checked')) {
                    addOnProp['I want this to be installed'] = 'Yes';
                  }
                }

                addOn['properties'] = addOnProp;
                jsonObj.push(addOn);

                // check add-on inventory
                var addOnInventoryInfo = addOnVariantContainer.find('.jsc-product__addon-inventory-info[data-vid="' + variant.id + '"]');
                var addOnInventoryQuantity = parseInt(addOnInventoryInfo.data('inventory'));
                var addOnIsContinueSelling = addOnInventoryInfo.data('is-continue');
                if(addOnIsContinueSelling === 'deny') {
                  setTimeout(() => {
                    var addOnInCart = currentCartItems.filter(function(obj) {
                      return obj.id === variant.id;
                    })
                    var totalAddOnInCartQuantity = addOnInCart.reduce(function(sum, obj) {
                      return sum + obj.quantity;
                    }, 0);
                    var newAddOnInCartQuantity = totalAddOnInCartQuantity + 1;
                    if(newAddOnInCartQuantity > addOnInventoryQuantity) {
                      canATC = false;
                      addOnErrorMsgText = '<span class="jsc-popup-addon-title">' + addOnTitle + '</span> for ' + productTitle + ' - ' + variantTitle + ' is out of stock.';
                    }
                  }, 600);
                }
                break;
              }
            }
            else {
              if(variant.option1 === addOnSelectedVariant && variant.option2 === lugWidthValue && variant.available === true) {
                var addOnTitle = variant.name.split(" - ")[0];
                var addOn = {};
                var addOnProp = {};
                addOn['id'] = variant.id;
                addOn['quantity'] = 1;
                addOnProp['_BundleId'] = bundleID;

                if (addOnDiscount > 0){
                  addOnProp['_Discount Type'] = "percentage-off";
                  addOnProp['_Discount Value'] = addOnDiscount;
                }

                if(installCheckbox.length > 0) {
                  if ($(installCheckbox).is(':checked')) {
                    addOnProp['I want this to be installed'] = 'Yes';
                  }
                }

                addOn['properties'] = addOnProp;
                jsonObj.push(addOn);

                // check add-on inventory
                var addOnInventoryInfo = addOnVariantContainer.find('.jsc-product__addon-inventory-info[data-vid="' + variant.id + '"]');
                var addOnInventoryQuantity = parseInt(addOnInventoryInfo.data('inventory'));
                var addOnIsContinueSelling = addOnInventoryInfo.data('is-continue');
                if(addOnIsContinueSelling === 'deny') {
                  setTimeout(() => {
                    var addOnInCart = currentCartItems.filter(function(obj) {
                      return obj.id === variant.id;
                    })
                    var totalAddOnInCartQuantity = addOnInCart.reduce(function(sum, obj) {
                      return sum + obj.quantity;
                    }, 0);
                    var newAddOnInCartQuantity = totalAddOnInCartQuantity + 1;
                    if(newAddOnInCartQuantity > addOnInventoryQuantity) {
                      canATC = false;
                      addOnErrorMsgText = '<span class="jsc-popup-addon-title">' + addOnTitle + '</span> for ' + productTitle + ' - ' + variantTitle + ' is out of stock.';
                    }
                  }, 600);
                }
                break;
              }
            }
          }
        }
      });

      if ($activeBuckleVariant.length > 0 && !$activeBuckleVariant.hasClass('included')) {
        var buckleId = parseInt($activeBuckleVariant.attr('data-id'));
        var buckleTitle = $activeBuckleVariant.parents('.jsc-buckle-option__tab-content-wrap.active').attr('data-title');
        var buckleItem = {
          'id': buckleId,
          'quantity': 1,
          'properties': {
            '_BundleId': bundleID,
            'I want this to be installed': 'Yes'
          }
        }
  
        if (buckleTitle.toLowerCase().includes('buckle')) {
          buckleItem['properties']['_BuckleSwap'] = 'Yes';
        }
  
        jsonObj.push(buckleItem);
      }

      console.log(jsonObj);

      var errorPopup = $('.jsc-pdp-error-popup');
      var errorMsg = $(errorPopup).find('.jsc-error-msg');
      var addonInstruction = $(errorPopup).find('.jsc-addon-instruction');
      if(addonallcheck === true) {
        setTimeout(() => {
          if(canATC === true) {
            CartJS.addItems(jsonObj,
            {
              // Define a success callback to display a success message.
              "success": function(data, textStatus, jqXHR) {
                  console.log('success');
                  $(document).on('cart.requestComplete', function(event, cart) {
                    var cartCount = $('.thb-item-count');
                    cartCount.text(cart.item_count);
                    closeQuickView();
                  });
                  errorPopup.hide();
              },
              // Define an error callback to display an error message.
              "error": function(jqXHR, textStatus, errorThrown) {
                console.log("Error occur !", textStatus);
              }
            });
          }
          else {
            // show popup
            if(prodErrorMsgText !== '') {
              errorMsg.text(prodErrorMsgText);
              errorMsg.addClass('jsc-product-error');
              errorMsg.removeClass('jsc-addon-error');
              addonInstruction.addClass('hide');
            }
            else {
              errorMsg.html(addOnErrorMsgText);
              errorMsg.addClass('jsc-addon-error');
              errorMsg.removeClass('jsc-product-error');
              addonInstruction.removeClass('hide');
            }
            errorPopup.show();
            console.log('not enough inventory');
          }
        }, 800);
      }
      else {
        errorPopup.hide();
        $('.jsc-addon-warning').text('');
        $('.jsc-addon-warning').text('Select the add-on product variant to add to cart');
        var allAddOnGrids = $('.jsc-product__addon-grid');
        allAddOnGrids.each(function(index, grid) {
          if($(grid).hasClass('addon-active')) {
            var addOnVariantContainer = $(grid).find('.jsc-product__addon-varopt');
            var addOnSelector = addOnVariantContainer.find('span:not(.hide) .jsc-single-selector');
            if(addOnSelector.val() === "") { // add-on activate but variant not selected
              $('.jsc-product__addon-wrap').flickity().flickity('select', index);
              $(addOnSelector).addClass('border-red');
              $(addOnSelector).addClass('shaking');
              return false;
            }
          }
        });
      }

      // to enable the default ATC button again
      setTimeout(function(){
        $(evt).prop('disabled', false);
      },1000);
    }
    else {
      // Check if backorder checkbox is visible and ticked (for non-addon flow)
      var $backorderWrapper = $('.jsc-backorder-checkbox-wrapper');
      if ($backorderWrapper.length > 0 && !$backorderWrapper.hasClass('hide') && $backorderWrapper.is(':visible')) {
        var $backorderCheckbox = $backorderWrapper.find('.jsc-backorder-checkbox');
        if ($backorderCheckbox.length > 0 && !$backorderCheckbox.is(':checked')) {
          return false; // Prevent form submission
        }
      }

      var defaultErrorMsgWrapper = $('.product-form__error-message-wrapper')[0];

      var errorPopup = $('.jsc-pdp-error-popup');
      var errorMsg = $(errorPopup).find('.jsc-error-msg');
      var addonInstruction = $(errorPopup).find('.jsc-addon-instruction');

      var mainProductVid = parseInt($('.jsc-var-pdp').val()); // main product variant id
      var mainProductInventoryInfo = $('.jsc-pdp-variant-inventory-info[data-vid="' + mainProductVid + '"]');
      var productTitle = mainProductInventoryInfo.data('prod-title');
      var variantTitle = mainProductInventoryInfo.data('var-title');

      var errorMsgText = productTitle + ' - ' + variantTitle + ' has been added to your cart.';

      setTimeout(() => {
        if(!$(defaultErrorMsgWrapper).is('[hidden]')){ // default error message is showing
          $(defaultErrorMsgWrapper).attr('hidden', true); // hide the message again

          errorMsg.text(errorMsgText);
          errorMsg.addClass('jsc-product-error');
          errorMsg.removeClass('jsc-addon-error');
          addonInstruction.addClass('hide');
          errorPopup.show();
        }
      }, 1500);
    }
  }
}
// end: addon pdp feature old

tierGwpQtyChecking = () =>{
  if ($('._getAllQtyGwpVid').length > 0){
    // var _getAllQtyGwpVid = $('._getAllQtyGwpVid').attr('all-vid');
    $.when($.getJSON('/cart.js', function(cart) {
      $cartItems = cart.items;

    })).then(function(){
      var processedGwpTiers = {};
      var gwpTierKeys = ['_GWP Tier 1', '_GWP Tier 2', '_GWP Tier 3', '_GWP Tier 4'];
      var tierVidMap = {};
      $('.jsc-tier-gwp-vid').each(function() {
        tierVidMap[$(this).attr('data-tier')] = parseInt($(this).attr('data-vid'), 10);
      });

      for (var i = 0; i < $cartItems.length; i++) {
        var vid = $cartItems[i].id;
        var qty = $cartItems[i].quantity;
        var key = $cartItems[i].key;
        var props = $cartItems[i].properties;

        if (props) {
          for (var j = 0; j < gwpTierKeys.length; j++) {
              var tierKey = gwpTierKeys[j];
  
              if (props[tierKey]) {
                  var tierNum = tierKey.replace('_GWP Tier ', '');
                  var $tierCfg = $('.jsc-tier-gwp-vid[data-tier="' + tierNum + '"]');
                  var expectedVid = tierVidMap[tierNum];

                  if (!$tierCfg.length || !expectedVid || vid !== expectedVid) {
                      cartJSUpdateQuery(key, 0);
                      continue;
                  }

                  var gwpTierValue = props[tierKey];
  
                  if (processedGwpTiers[tierKey]?.includes(gwpTierValue)) {
                      // If the tier value for this tierKey is already processed, remove the item
                      cartJSUpdateQuery(key, 0); // Set quantity to 0 or remove the item
                  } else {
                      // If not processed, initialize array for this tierKey if necessary
                      if (!processedGwpTiers[tierKey]) {
                          processedGwpTiers[tierKey] = [];
                      }
  
                      // Mark the current value as processed
                      processedGwpTiers[tierKey].push(gwpTierValue);
  
                      // Optional: If the quantity is greater than 1, update it to 1
                      if (qty > 1) {
                          cartJSUpdateQuery(key, 1);
                      }
                  }
              }
          }
      }

        // if (_getAllQtyGwpVid.includes(vid.toString())) { // Convert vid to string to match includes
        //   if (qty > 1){
        //     console.log(vid,qty,'qty');
        //     $('.jsc-checkout').attr('disabled',true); 
        //     cartJSUpdateQuery(vid,1);
        //   }
        // }
      }

    });  
  } 
}

tierGwp = () =>{
  var $addEle = $('.jsc-add-tierGwp');
  var $removeEle = $('.jsc-remove-tierGwp');

  // Fetch current cart items
  $.getJSON('/cart.js', function(cart) {
    var cartItems = cart.items;

    $removeEle.each(function() {
      var $key = $(this).attr('data-key');
      if ($(this).length > 0) {
        cartJSUpdateQuery($key, 0);
      }
    });

    $addEle.each(function() {
      var $gwpcart_product = {};
      var $vid = parseInt($(this).attr('data-vid'));
      var $tierNo = $(this).attr('data-tier');
      var tierProperty = '_GWP Tier ' + $tierNo;
      var isTierInCart = cartItems.some(item =>
        item.properties && item.properties[tierProperty] && item.id === $vid
      );

      if (!isTierInCart) {
        $gwpcart_product[tierProperty] = true;
        $gwpcart_product['_GWP'] = true;
        cartJSAddQuery($vid, 1, $gwpcart_product, true);
      }
    });
  });
};

// start: strap filter
getSelectedStrap = (e) => {
  var strapOption = $(e).find('option:selected').text();
  populateWidthSelector(strapOption);
  updateSelectorWidth($(e), strapOption);
}

getSelectedWidth = (e) => {
  var widthOption = $(e).find('option:selected').text();
  updateSelectorWidth($(e), widthOption);
}

populateWidthSelector = (strapOption) => {
  var widthSelector = $('.jsc-section-strap-filter .jsc-strap-filter-form #jsc-width-select');

  widthSelector.empty();
  widthSelector.append($('<option>', {
    value: "",
    text: "Select width",
    style: 'display: none;'
  }));
  updateSelectorWidth(widthSelector, "Select width");

  if(strapOption !== "Select strap") {
    var widthOptionInfo = $(widthSelector).siblings('input[data-strap="' + strapOption + '"]:not(.jsc-custom-product)').val().split(',');
    var customWidthOption = $(widthSelector).siblings('input[data-strap="' + strapOption + '"].jsc-custom-product');
    $.each(widthOptionInfo, function(index) {
      var optionText = widthOptionInfo[index].split(':')[0];
      var optionValue = widthOptionInfo[index].split(':')[1];
      widthSelector.append($('<option>', {
        value: optionValue,
        text: optionText
      }));
    });
    if(customWidthOption.length > 0) {
      widthSelector.append($('<option>', {
        value: customWidthOption.val(),
        text: "Custom"
      }));
    }
  }
}

onloadUpdateStrapSelectorWidth = () => {
  var strapSelector = $('.jsc-section-strap-filter .jsc-strap-filter-form #jsc-strap-select');
  updateSelectorWidth(strapSelector, "Select strap");
}

updateSelectorWidth = (selector, text) => {
  var size;
  if($(window).width() < 481){
    size = '17px';
  }
  else {
    size = '25px';
  }
  var hiddenSpan = $("<span>")
    .css({
      visibility: "hidden",
      position: "absolute",
      whiteSpace: "nowrap",
      'font-size': size,
      'font-family' : "Goudy Old Style"
    })
    .text(text)
    .appendTo("body");
  selector.css("width", hiddenSpan.outerWidth(true)+45 + 'px');
  hiddenSpan.remove();
}

filterStrapCollection = (e) => {
  var strapSelector = $('.jsc-section-strap-filter .jsc-strap-filter-form #jsc-strap-select');
  var widthSelector = $('.jsc-section-strap-filter .jsc-strap-filter-form #jsc-width-select');

  if(strapSelector.val() != "" && widthSelector.val() != "") {
    var widthOptionText = $(widthSelector).find('option:selected').text();
    if(widthOptionText == "Custom") {
      window.location.href = widthSelector.val();
      console.log('custom product');
    }
    else {
      var encodedWidthValue = encodeURIComponent(widthSelector.val()).replace(/%20/g, '+') .replace(/\(/g, '%28').replace(/\)/g, '%29');
      var filterUrl = strapSelector.val() + "?filter.v.option.lug+width+%28lug-buckle%29=" + encodedWidthValue; 
      window.location.href = filterUrl;
    }
  }
}
// end: strap filter

sliderBlogGridHeight = () => {
  setInterval(function() {
    var maxInfoHeight = 0;
    var maxCardHeight = 0;

    var viewport = $('.initBlogSlider .flickity-viewport');
    var productGrid = $('.flickity-slider .blog-post');
    $.each(productGrid, function(index, grid) {
      var thisGrid = $(grid);
      var cardHeight = thisGrid.outerHeight(true);
      var infoHeight = thisGrid.find('.blog-post-info').outerHeight(true);

      if(maxInfoHeight < infoHeight) {
        maxInfoHeight = infoHeight;
      }
      if(maxCardHeight < cardHeight) {
        maxCardHeight = cardHeight;
      }
    });

    productGrid.find('.blog-post-info').css('min-height', maxInfoHeight + 'px');
    // viewport.css('height', maxCardHeight+8 + 'px');
  }, 100)
}

sliderGridHeight = () => {
  setInterval(function() {
    var maxInfoHeight = 0;
    var maxCardHeight = 0;

    var viewport = $('.template-index .products.carousel .flickity-viewport');
    var productGrid = $('.flickity-slider product-card');
    $.each(productGrid, function(index, grid) {
      var thisGrid = $(grid);
      var cardHeight = thisGrid.outerHeight(true);
      var infoHeight = thisGrid.find('.product-card-info').outerHeight(true);

      if(maxInfoHeight < infoHeight) {
        maxInfoHeight = infoHeight;
      }
      if(maxCardHeight < cardHeight) {
        maxCardHeight = cardHeight;
      }
    });

    productGrid.find('.product-card-info').css('height', maxInfoHeight + 'px');
    viewport.css('height', maxCardHeight+8 + 'px');
  }, 100)
}

pdpSliderGridHeight = () => {
  setInterval(function() {
    var maxInfoHeight = 0;
    var maxCardHeight = 0;

    var viewport = $('.template-product .products.carousel .flickity-viewport');
    var productGrid = $('.flickity-slider product-card');
    $.each(productGrid, function(index, grid) {
      var thisGrid = $(grid);
      var cardHeight = thisGrid.outerHeight(true);
      var infoHeight = thisGrid.find('.product-card-info').outerHeight(true);

      if(maxInfoHeight < infoHeight) {
        maxInfoHeight = infoHeight;
      }
      if(maxCardHeight < cardHeight) {
        maxCardHeight = cardHeight;
      }
    });

    productGrid.find('.product-card-info').css('height', maxInfoHeight + 'px');
    viewport.css('height', maxCardHeight+8 + 'px');
  }, 100)
}

initFeaturedBlogSlider = () => {

    if ($('.initBlogSlider').length > 0){
      $('.initBlogSlider').flickity({
        cellAlign: 'left',
        wrapAround: false,
        contain: true,
        pageDots: false,
        imagesLoaded: true,
        prevNextButtons: true
      });;
    }
  
}

// start: Klaviyo coming soon notification
openEmailForm = () => {
  var emailModal = $('.jsc-email-form-modal');
  emailModal.show();
}

closeEmailForm = () => {
  var emailModal = $('.jsc-email-form-modal');
  emailModal.hide();
}

triggerKlaviyo = (e) => {
  // email input validation
  var email = $(e).siblings('.jsc-email-form-field').find('.jsc-email-input').val();
  var validationMessage = $(e).siblings('.jsc-email-validation');
  var isEmailValid = false;
  if(email.length <= 0) {
    validationMessage.text('Please fill in your email address');
    validationMessage.show();
  }
  else {
    var emailRegex = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (emailRegex.test(email)) {
      validationMessage.hide();
      isEmailValid = true;
    } else {
      validationMessage.text('Please fill a valid email address');
      validationMessage.show();
    }
  }

  // get product data
  if(isEmailValid == true) {
    var productId = $(e).data('product-id');
    var productName = $(e).data('product-name');
    var vid = $(e).data('vid');
    var variantName = $(e).data('variant-name');
    var sku = $(e).data('sku');
    var price = $(e).data('price');

    var item = {
      "ProductID": productId,
      "ProductName": productName,
      "Categories": [],
      "platform": "Shopify",
      "Channels": [
        "EMAIL"
      ],
      "VariantId": vid,
      "VariantName": variantName,
      "SKU": sku,
      "Price": price
    };

    klaviyo.push(['identify', {'$email' : email}]); // determine profile
    klaviyo.push(['track', 'Subscribe to Coming Soon Launch', item]); // track profile activity

    var submitMessage = $('.jsc-submission-success');
    submitMessage.show();
    $(e).hide();
  }
}
// end: Klaviyo coming soon notification

detectUserTimezone = () => {
  var dateString = $('.jsc-coming-soon-notify .jsc-launch-date').text();
  var utcDate = new Date(dateString);
  var options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  };
  var localDate = utcDate.toLocaleString('en-US', options);

  var formattedDate = localDate.replace(/(\w+) (\d+), (\d+),/, function (_, month, day, year) {
    return day + ' ' + month + ' ' + year;
  });
  $('.jsc-coming-soon-notify .jsc-launch-date').text(formattedDate);
}

checkDiscontProduct = (e) => {
  var vid = parseInt($(e).val());
  var variantDataInput = $(e).siblings("input[name='jsc-product-variants-info']");
  var isDiscont = variantDataInput.data('is-discont');
  if(isDiscont) {
    var variantsData = JSON.parse($(variantDataInput).val());
    for(var variant of variantsData) {
      if (variant.id === vid && variant.available == false) {
        var bisButton = $('._jsc-pdp-bis');
        bisButton.attr('disabled', 'disabled');
        $(bisButton).find('span').text('Discontinued');
        break;
      }
    }
  }
}

initPopupAfterRegister = () => {
  sessionStorage.setItem("jsc-from-register-page", 1);
}

anchorToCollectionGrid = (e) => {
  if($(e).parents('.template-collection').length > 0) { // button inside collection page
    var linkValue = $(e).attr('href');
    if(linkValue && linkValue == '#productGrid') {
      $('html').animate({
        scrollTop: $("#product-grid").offset().top - 270
      }, 500);
    }
  }
}

let closeButtonClicked = false;

checkCustomerStatus = () => {
  var login_status = $(".jsc-modal-overlay").attr("data-login-status");
  var order_count = $(".jsc-modal-overlay").attr("data-order-count");
  var currentPageTitle = $(".jsc-modal-overlay").attr("data-page-title");
  var isNewModalEnable = $(".jsc-modal-overlay").attr("data-new-modal-isEnable");
  var isExistModalEnable = $(".jsc-modal-overlay").attr("data-exist-modal-isEnable");
  var exist_visible_before_cart = sessionStorage.getItem("jsc-showExistAccModal-modal-cart");
  var exist_visible_before_acc = sessionStorage.getItem("jsc-showExistAccModal-modal-acc");
  var exist_visible_before_home = sessionStorage.getItem("jsc-showExistAccModal-modal-home");
  var fromRegisterPage =   sessionStorage.getItem("jsc-from-register-page");
  var new_visible_before = sessionStorage.getItem("jsc-showNewAccModal-modal");
  var new_modal_delay_time = parseInt($(".jsc-modal-overlay").attr("data-new-modal-delay-time"));
  
  if(login_status == "true" && !exist_visible_before_cart && currentPageTitle == 'Your Shopping Cart' && isExistModalEnable == 'enable'){
    showExistAccModal();
  }else if(login_status == "true" && !exist_visible_before_acc && currentPageTitle == 'Account' && isExistModalEnable == 'enable'){
    showExistAccModal();
  }else if(login_status == "true" && !exist_visible_before_home && fromRegisterPage && currentPageTitle == 'Handcrafted Watch Straps | Delugs' && isExistModalEnable == 'enable'){
    showExistAccModal();
  } else if(login_status == "false" && !new_visible_before && isNewModalEnable == 'enable' && order_count == '0') {
    showNewAccModal(new_modal_delay_time);
  }
} 

showExistAccModal = () => {
  $(".jsc-modal-overlay").show();
  $("#exist_user_modal").css("display", "flex");
} 

showNewAccModal = (delay_time) => {
  setTimeout(() => {
    $(".jsc-modal-overlay").show();
    $("#new_user_modal").css("display", "flex");
  }, delay_time);
}

$(".jsc-submit-button").click(function() {
  var currentPageTitle = $(".jsc-modal-overlay").attr("data-page-title");
  var fromRegisterPage =   sessionStorage.getItem("jsc-from-register-page");
  if(currentPageTitle == 'Your Shopping Cart'){
    sessionStorage.setItem("jsc-showExistAccModal-modal-cart", 1);
  }else if(currentPageTitle == 'Account'){
    sessionStorage.setItem("jsc-showExistAccModal-modal-acc", 1);
  }else if(currentPageTitle == 'Handcrafted Watch Straps | Delugs' && fromRegisterPage){
    sessionStorage.setItem("jsc-showExistAccModal-modal-home", 1);
  }
  $(".jsc-modal-overlay, #exist_user_modal").hide();
})

$(".jsc-close-button").click(function() {
  sessionStorage.setItem("jsc-showNewAccModal-modal", 1);
  $(".jsc-modal-overlay, #new_user_modal").hide();
})

$(".jsc-new-user-submit-button, .jsc-new-user-modal-link").click(function() {
  sessionStorage.setItem("jsc-showNewAccModal-modal", 1);
})



// start: advanced sizing option
toggleSizeSelector = (e) => {
  var $sizeSelector = $('fieldset.lug-size-select');
  var $advancedSelectWrapper = $($sizeSelector).find('.jsc-advanced-sizing-selector-wrapper');
  var $fakeSelector = $($advancedSelectWrapper).siblings('.jsc-fake-size-selector');
  var $hiddenSelector = $($advancedSelectWrapper).siblings('.jsc-hidden-size-selector');

  // var $standardSelector = $($advancedSelectWrapper).siblings('.select');

  // reset selector
  $($advancedSelectWrapper).find('.select select').find('option').prop('disabled', false);
  $($advancedSelectWrapper).find('.select select').find('option').removeProp('selected');
  $($advancedSelectWrapper).find('.select select').find('option[value=""]').prop('selected', 'selected');
  $($advancedSelectWrapper).find('.select select').val('').change();

  $($hiddenSelector).find('select').find('option').prop('disabled', false);
  $($hiddenSelector).find('select').find('option').removeProp('selected');
  $($hiddenSelector).find('select').find('option[value=""]').prop('selected', 'selected');
  $($hiddenSelector).find('select').val('').change();

  $($fakeSelector).find('select').find('option').prop('disabled', false);
  $($fakeSelector).find('select').find('option').removeProp('selected');
  $($fakeSelector).find('select').find('option[value=""]').prop('selected', 'selected');
  $($fakeSelector).find('select').val('').change();

  if($(e).is(':checked')) {
    $advancedSelectWrapper.show();
    $fakeSelector.hide();
  }
  else {
    $advancedSelectWrapper.hide();
    $fakeSelector.show();
  }
}

onLoadToggleSizeSelector = () => {
  var selectedVid = $('.jsc-var-pdp').val();
  var $standardSizeSelector = $('fieldset.lug-size-select .jsc-advanced-sizing-selector-wrapper').siblings('.select').find('select');
  var $selectedOption = $standardSizeSelector.find('option:selected');
  var selectedValue = $standardSizeSelector.val();
  
  if(selectedVid !== "") { // variant is selected on load
    if($selectedOption.attr('data-advanced-sizing') !== undefined) {
      // toggle to advanced sizing selector
      var $advancedSizingCheckbox = $('input[name="jsc-advanced-sizing-check"]');
      $advancedSizingCheckbox.prop('checked', true).change();

      // select the value according to variant
      var temp = selectedValue.split('/');
      var longEndValue = temp[0];
      var shortEndValue = temp[1];
      $('#jsc-advanced-long-end').val(longEndValue).change();
      $('#jsc-advanced-short-end').val(shortEndValue).change();
    }
  } 
}

// disableInvalidPair = (e) => {
//   var productSizeVariants = JSON.parse($("input[name='jsc-product-size-variants']").val()); // size variant data

//   var currentValue = $(e).val();
//   var currentSelectorEnd = $(e).data('end'); // long end or short end
//   var $currentSelectorWrapper = $(e).parent();

//   if(currentValue !== "")
//   {
//     var $otherSelectorWrapper = $($currentSelectorWrapper).siblings('div');
//     var $otherSelector = $($otherSelectorWrapper).find('select');
  
//     var relatedVariant = productSizeVariants.filter(function(obj) {
//       return obj.includes(currentValue);
//     })
  
//     // check pairing and disable invalid pair
//     $($otherSelector).find('option').each(function() {
//       var value = $(this).val();
//       var searchValue;
      
//       if(currentSelectorEnd === 'long') {
//         searchValue = currentValue + '/' + value;
//       }
//       else {
//         searchValue = value + '/' + currentValue;
//       }

//       var isValid = relatedVariant.filter(function(obj) {
//         var cleanedValue = obj.replace(/[A-Za-z()\s]/g, '');
//         return cleanedValue.includes(searchValue) || obj.includes(searchValue)
//       })

//       if(isValid.length > 0) {
//         $(this).prop('disabled', false);
//       }
//       else {
//         $(this).prop('disabled', true);
//       }
//     })
//   }
// }

updateSelectedVariant = () => {
  var longEndValue = $('fieldset.lug-size-select .jsc-advanced-sizing-selector-wrapper #jsc-advanced-long-end').val();
  var shortEndValue = $('fieldset.lug-size-select .jsc-advanced-sizing-selector-wrapper #jsc-advanced-short-end').val();
  var $standardSizeSelector = $('fieldset.lug-size-select .jsc-advanced-sizing-selector-wrapper').siblings('.jsc-hidden-size-selector').find('select');
  var option = $standardSizeSelector.find('option');

  if(longEndValue !== null && shortEndValue !== null) {
    option.removeProp('selected');

    var selectedSizeVariant = longEndValue + '/' + shortEndValue;

    $(option).each(function() {
      var value = $(this).val();
      var cleanedValue = value.replace(/[A-Za-z()\s]/g, '');
      if(cleanedValue === selectedSizeVariant) {
        $standardSizeSelector.val(value).change();
      }
    })
  }
}

updateHiddenSelector = (e) => {
  var currentValue = $(e).val();
  var $hiddenSelector = $(e).parent().siblings('.jsc-hidden-size-selector').find('select');

  if(currentValue != "") {
    $hiddenSelector.val(currentValue).change();
  }
}
// end: advanced sizing option

// start: enable in stock filter
enableInStockFilter = () => {
  // Set initial value to true only if it doesn't exist in session storage
  if (!sessionStorage.getItem('activateInStock')) {
    sessionStorage.setItem('activateInStock', 'true');
  }

  var url = window.location.href;
  var hasBrandParam = url.includes('?brand=') || url.includes('&brand=');
  var isPageParam = url.includes('?page=');
  var isCollection = url.includes('collections');
  var isFilterActive = url.includes('filter.v.availability=1');
  var activateInStock = sessionStorage.getItem('activateInStock');

  if (!hasBrandParam && !isPageParam) {
    if(isCollection && isFilterActive === false && activateInStock === 'true') {
      var inStockToggle = $('input[name="filter.v.availability"]')
      inStockToggle.each(function() {
        if(!$(this).prop('checked')) {
          $(this).click();
        }
      });
    }
  }
}

updateInStockStatus = (e) => {
  var isChecked = $(e).prop('checked');
  sessionStorage.setItem('activateInStock', isChecked);
}
// end: enable in stock filter

// start: logo tab
toggleLogoTab = (e) => {
  var $otherTabs = $(e).siblings();
  $otherTabs.removeClass('active');
  $(e).addClass('active')

  var selectedTabName = $(e).data('tab-name');
  var $logoList = $(e).parent().parent().find('.logo-list--inner');
  $($logoList).find('.jsc-logo-tab-logo').removeClass('active');
  $($logoList).find('.jsc-logo-tab-logo[data-tab-name="' + selectedTabName + '"]').addClass('active');
}
// end: logo tab

// start: hide seo.hidden variant (working for standard 2 variant option only)
disableHiddenVariant = (e) => {
  // current selector info
  var selectedValue = $(e).val();
  var $selectorWrapper = $(e).parents('fieldset.product-form__input');
  var optionIndex = $selectorWrapper.data('index');

  // variant info
  var $variantInfo = $('.jsc-pdp-variant-info-container').find('.jsc-variant-info')

  var $otherSelectorWrapper = $selectorWrapper.siblings('fieldset.product-form__input');
  $otherSelectorWrapper.each(function() {
    var selectorOptionIndex = $(this).data('index');
    var $selector = $(this).find('.select select');
    var $options = $($selector).find('option');

    $options.each(function(index, option) {
      var isDisable = true;
      var optVal = $(option).val();
      if(optVal !== '') {
        $variantInfo.each(function(index, variant) {
          if($(variant).data(optionIndex) === selectedValue && $(variant).data(selectorOptionIndex) === optVal) {
            if($(variant).data('is-hidden') === false) {
              isDisable = false;
            }
          }
        });

        setTimeout(() => {
          if(isDisable === true) {
            $(option).prop("disabled", true);
          }
          else {
            $(option).prop("disabled", false);
          }
        }, 500);
      }
    });
  });
}
// end: hide seo.hidden variant
clearReturnValue = (e) => {
  var $returnToInput = $(e).siblings('input[name="return_to"]');
  $returnToInput.val('');
}

// start: media grid view more
showMedia = (e) => {
  var $mediaGridContainer = $('.media-grid .media-grid--inner');
  var $mediaGrids = $($mediaGridContainer).find('.media-grid--item');
  var desktopGrids = parseInt($mediaGridContainer.attr('data-desktop-grids'));
  var mobileGrids = parseInt($mediaGridContainer.attr('data-mobile-grids'));

  if($(window).width() > 480) {
    var currentLastIndex = parseInt($($mediaGridContainer).find('.media-grid--item:not(.jsc-hide-desktop)').last().attr('data-index'));
    var newLastIndex = currentLastIndex + desktopGrids;
    $mediaGrids.slice(currentLastIndex, newLastIndex).removeClass('jsc-hide-desktop');

    if(newLastIndex > $mediaGrids.length) {
      $(e).parent().css('display', 'none');
    }
  }
  else {
    var currentLastIndex = parseInt($($mediaGridContainer).find('.media-grid--item:not(.jsc-hide-mobile)').last().attr('data-index'));
    var newLastIndex = currentLastIndex + mobileGrids;
    $mediaGrids.slice(currentLastIndex, newLastIndex).removeClass('jsc-hide-mobile');

    if(newLastIndex > $mediaGrids.length) {
      $(e).parent().css('display', 'none');
    }
  }
}
// end: media grid view more

// start: announcement bar currency selector position
updateAnnouncementCurrencySelector = () => {
  var $selectorList = $('#AnnouncementLocalization .custom-select--list');
  var $selectorBtn = $('#AnnouncementLocalization .custom-select--button');
  if($selectorBtn.length > 0) {
    const rect = $selectorBtn[0].getBoundingClientRect();
    const distanceFromRight = window.innerWidth - rect.right - 10;
    $selectorList.css('right', distanceFromRight);
  }
}
// end: announcement bar currency selector position

// start: pdp properties slider
initPropertiesSlider = () => {
  var $slider = $('.jsc-pdp-properties-wrapper .jsc-pdp-properties-content:not(".jsc-properties-grid")');
  if($slider.length > 0) {
    $slider.flickity({
      cellAlign: 'left',
      draggable: true,
      contain: true,
      pageDots: false,
      prevNextButtons: false
    });
  }
}
// end: pdp pdp properties slider

// start: pdp tag page slider
initTagPageSlider = () => {
  var $slider = $('.display-tag-pages__container.jsc-tag-page-slider');
  if($slider.length > 0) {
    $slider.flickity({
      cellAlign: 'left',
      draggable: true,
      contain: true,
      pageDots: false,
      prevNextButtons: false
    });

    var $sliderNavContainer = $($slider).siblings('.display-tag-pages__nav-container');
    var $currentPageNum = $($sliderNavContainer).find('.jsc-current-page');
    $slider.on( 'change.flickity', function(event, index) {
      $currentPageNum.text(index + 1);
    });
  }
}

tagPageNext = () => {
  var $slider = $('.display-tag-pages__container.jsc-tag-page-slider');
  $slider.flickity('next');
}

tagPagePrev = () => {
  var $slider = $('.display-tag-pages__container.jsc-tag-page-slider');
  $slider.flickity('previous');
}
// end: pdp tag page slider

// start: mobile product grid image slider
initProductGridImgSlider = () => {
  if($(window).width() < 1025) {
    var $productGrid = $('#ProductGridContainer .product-card');
    if ($productGrid.length > 0){
      $($productGrid).each(function(index, grid) {
        var $productLinkImage = $(grid).find('.product-featured-image .product-featured-image-link');
          $($productLinkImage).flickity({
            pageDots: true,
            draggable: true,
            contain: true,
            cellAlign: "left",
            prevNextButtons: false,
            imagesLoaded: true,
            adaptiveHeight: true,
            wrapAround: true
          });
      });
    }
  }
}
// end: mobile product grid image slider

// start: pre order
updatePdpPreorder = (evt) => {
  var vid = parseInt($(evt).val());
  var isPreorder = $(evt).attr('data-is-preorder');
  var variantInfo = JSON.parse($(evt).siblings("input[name='jsc-product-variants-info']").val());
  var currentVariant = variantInfo.find(obj => obj.id == vid);
  var $preorderLabel = $('.product-card--label.jsc-pdp-preorder-label');
  var isShowPreorderLabel = false
  var $preorderText = $(evt).siblings('.product-add-to-cart-container').find('.jsc-preorder-text-wrap');
  var $preorderProps = $('<input>', {type: 'hidden', class: 'jsc-preorder-prop', name: 'properties[Pre-order]'});
  var $originalPreorderProps = $(evt).siblings('.jsc-preorder-prop');

  if (isPreorder == 'true' && currentVariant != undefined) {
    var inventoryQuantity = parseInt($('.jsc-pdp-variant-inventory-info[data-vid="' + vid + '"]').attr('data-inventory'));
    var inventoryPolicy = $('.jsc-pdp-variant-inventory-info[data-vid="' + vid + '"]').attr('data-is-continue');
    var isClaspOOS = $('.jsc-pdp-variant-inventory-info[data-vid="' + vid + '"]').attr('data-is-clasp-oos');
    var sizeValue = currentVariant.option1;
    var sizeVariantList = $(evt).siblings('.jsc-preorder-size-variant').val().split(',');
    var lineText = $('.jsc-pdp-variant-inventory-info[data-vid="' + vid + '"]').attr('data-line-text');
    var tooltipText = $('.jsc-pdp-variant-inventory-info[data-vid="' + vid + '"]').attr('data-tooltip-text');

    if(sizeVariantList.includes(sizeValue) && inventoryPolicy == 'continue') {
      isShowPreorderLabel = true;
    }
    else if (isClaspOOS == 'true' && inventoryPolicy == 'continue') {
      isShowPreorderLabel = true
    }
    else if (inventoryQuantity <= 0 && inventoryPolicy == 'continue') {
      isShowPreorderLabel = true;
    }
  }

  if (isShowPreorderLabel) {
    $preorderLabel.removeClass('hide');
    $preorderText.find('.jsc-preorder-text').text(lineText);
    $preorderText.find('.jsc-preorder-tooltip').text(tooltipText);
    $preorderText.removeClass('hide');

    if ($originalPreorderProps.length > 0) {
      $originalPreorderProps.val(lineText);
    }
    else {
      $preorderProps.val(lineText);
      $(evt).after($preorderProps);
    }
  }
  else {
    $preorderLabel.addClass('hide');
    $preorderText.addClass('hide');

    if ($originalPreorderProps.length > 0) {
      $originalPreorderProps.remove();
    }
  }
}

updatePreorderProps = () => {
  $('.jsc-update-preorder').each(function() {
    var isPreorder = $(this).attr('data-is-preorder');
    var lineText = $(this).attr('data-line-text');
    var key = $(this).attr('data-key');

    if (lineText == '') {
      lineText = undefined;
    }

    $.getJSON('/cart.js', function(cart) {
      for (var i = 0; i < cart.items.length; i++) {
        var itemKey = cart.items[i].key;
        var itemQty = cart.items[i].quantity;
        var itemProps = cart.items[i].properties;
        var preorderValue = itemProps['Pre-order'];

        if (key == itemKey) {
          if (lineText != preorderValue) {
            itemProps['Pre-order'] = lineText;
            cartJSUpdateQuery(itemKey, itemQty, itemProps);
          }
        }
      }
    });
  });
}

sendPreorderEmail = (evt) => {
  var recipient = $(evt).attr('email-recipient');
  var subject = $(evt).attr('email-subject');
  var body = $(evt).attr('email-body');

  if (recipient != '' && subject != '') {
    var mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  }
}
// end: pre order

// start: buckle options
toggleBuckleTab = (evt) => {
  var index = $(evt).attr('data-index');
  var $buckleTab = $(evt).parents('.jsc-buckle-option__content').find(`.jsc-buckle-option__tab-content-wrap[data-index="${index}"]`);

  $(evt).addClass('active');
  $(evt).siblings('.jsc-buckle-option__tab').removeClass('active');
  $buckleTab.addClass('active');
  $buckleTab.siblings('.jsc-buckle-option__tab-content-wrap').removeClass('active');
}

updateBuckleOption = () => {
  var $buckleOption = $('.jsc-buckle-option__wrap');
  if ($buckleOption.length > 0) {
    var $buckleContent = $buckleOption.find('.jsc-buckle-option__content');
    var $warning = $buckleOption.find('.jsc-buckle-option__warning');
    var lugWidthValue = getLugWidthValue();
    if (lugWidthValue == null) {
      $buckleContent.addClass('disabled');
      $warning.text('Please select your lug-width before selecting buckle');
    }
    else {
      $buckleContent.removeClass('disabled');
      $warning.text('');
      updateBuckleAvailability();
      updateBuckleImage();
      updatePdpPrice();
    }
  }
}

updateBuckleAvailability = () => {
  var $buckleTab = $('.jsc-buckle-option__wrap .jsc-buckle-option__tab-content-wrap');
  var lugWidthValue = getLugWidthValue();

  if ($buckleTab.length > 0) {
    $buckleTab.each(function(index, $tab) {
      var $variantInfo = $($tab).find('.jsc-buckle-option__variant-info');
      var productJson = JSON.parse($($tab).find('.jsc-buckle-option__variant-info').attr('data-addon'));
      var widthIndex = getVariantOptionIndex($variantInfo, 'Width');
      var colorIndex = getVariantOptionIndex($variantInfo, 'Color');
      var $buckleVariants = $($tab).find('.jsc-buckle-option__variant');

      if (widthIndex != -1 && colorIndex != -1) {
        $buckleVariants.each(function() {
          var color = $(this).attr('data-color');
          var variant = productJson.variants.find(obj => obj[`option${colorIndex}`] == color && obj[`option${widthIndex}`] == lugWidthValue);
          if (variant != undefined) {
            $(this).attr('data-id', variant.id);
            $(this).attr('variant-title', variant.title);
            if (variant.available == true) {
              $(this).removeClass('disabled');
            }
            else {
              $(this).addClass('disabled');
            }
          }
          else {
            $(this).addClass('disabled');
          }
        });
      }
      else if (widthIndex != -1) {
        $buckleVariants.each(function() {
          var variant = productJson.variants.find(obj => obj[`option${widthIndex}`] == lugWidthValue);
          if (variant != undefined) {
            $(this).attr('data-id', variant.id);
            $(this).attr('variant-title', variant.title);
            if (variant.available == true) {
              $(this).removeClass('disabled');
            }
            else {
              $(this).addClass('disabled');
            }
          }
          else {
            $(this).addClass('disabled');
          }
        });
      }
      else if (colorIndex != -1) {
        $buckleVariants.each(function() {
          var color = $(this).attr('data-color');
          var variant = productJson.variants.find(obj => obj[`option${colorIndex}`] == color);
          if (variant != undefined) {
            $(this).attr('data-id', variant.id);
            $(this).attr('variant-title', variant.title);
            if (variant.available == true) {
              $(this).removeClass('disabled');
            }
            else {
              $(this).addClass('disabled');
            }
          }
          else {
            $(this).addClass('disabled');
          }
        });
      }
    });

    var $defaultVariant = $('.jsc-buckle-option__wrap').find('.jsc-buckle-option__variant:not(.disabled):first');
    if ($defaultVariant.length <= 0) {
      $defaultVariant = $('.jsc-buckle-option__wrap').find('.jsc-buckle-option__variant:first');
    }
    $defaultVariant.addClass('active');
  }
}

toggleBuckleOption = (evt) => {
  var $buckleVariants = $(evt).parents('.jsc-buckle-option__wrap').find('.jsc-buckle-option__variant');
  $buckleVariants.removeClass('active');
  $(evt).addClass('active');
  updateBuckleImage();
  updatePdpPrice();
}

updateBuckleImage = () => {
  var $buckleOptionWrap = $('.jsc-buckle-option__wrap');
  if ($buckleOptionWrap.length > 0) {
    var $pdpContainer = $buckleOptionWrap.parents('.product-grid-container');
    var $pdpSlider = $pdpContainer.find('#Product-Slider');
    var $featuredSlide = $pdpSlider.find('.product-images__slide').first();
    var $activeBuckle = $buckleOptionWrap.find('.jsc-buckle-option__tab-content-wrap.active .jsc-buckle-option__variant.active');
    var buckleImage = $activeBuckle.attr('data-buckle-image');

    if (buckleImage != undefined && $activeBuckle.length > 0) {
      var $imgEle = $featuredSlide.find('img');
      $imgEle.attr('srcset', '');
      $imgEle.attr('src', buckleImage);
    }
  }
}

formatMoney = (cents, format, currency) => {
  const noDecimals = ['JPY', 'KRW'];
  const isZeroDecimal = noDecimals.includes(currency);

  let value = isZeroDecimal
    ? Math.round(cents).toLocaleString('en-US') // for JPY: 176000 → "176,000"
    : (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  let valueNoDecimals = Math.round(cents / 100).toLocaleString('en-US');

  let valueWithCommaSeparator = (cents / 100).toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  let valueWithCommaSeparatorNoDecimals = Math.round(cents / 100).toLocaleString('de-DE');

  return format
    .replace('{{amount}}', value)
    .replace('{{amount_no_decimals}}', valueNoDecimals)
    .replace('{{amount_with_currency}}', value)
    .replace('{{amount_no_decimals_with_currency}}', valueNoDecimals)
    .replace('{{amount_with_comma_separator}}', valueWithCommaSeparator)
    .replace('{{amount_with_comma_separator_with_currency}}', valueWithCommaSeparator)
    .replace('{{amount_no_decimals_with_comma_separator}}', valueWithCommaSeparatorNoDecimals)
    .replace('{{amount_no_decimals_with_comma_separator_with_currency}}', valueWithCommaSeparatorNoDecimals);
}

updatePdpPrice = () => {
  setTimeout(() => {
    var $pdpPriceWrap = $('.product-information .jsc-reset-price-wrapper');
    var $activeBuckleOption =  $('.jsc-buckle-option__wrap .jsc-buckle-option__tab-content-wrap.active');

    if ($pdpPriceWrap.length > 0 && $activeBuckleOption.length > 0) {
      var $activeBuckleVariant = $activeBuckleOption.find('.jsc-buckle-option__variant.active');
      if ($activeBuckleVariant.length > 0) {
        var moneyFormat = $activeBuckleOption.attr('data-money-format');
        var currency = $activeBuckleOption.attr('data-currency');
        var mainPrice = parseInt($pdpPriceWrap.attr('data-main-price'));
        var bucklePrice = parseInt($activeBuckleVariant.attr('data-buckle-price'));
        var totalPrice = mainPrice + bucklePrice;
        var formattedPrice = formatMoney(totalPrice, moneyFormat, currency);
        $pdpPriceWrap.find('.price .amount').text(formattedPrice);  
      }
    }
  }, 1000);
}
// end: buckle options

// start: shell product watch model
removeWatchModelOptions = () => {
  var $variantSelect = $('.product-information variant-selects');
  $variantSelect.find('option[watch-mode-remove-option]').remove();
}
// end: shell product watch model

// start: redirect to lug width selection from strap finder
onLoadPullAndChangeLugWidth = () => {
  var currentUrl = window.location.href;
  if (currentUrl.includes("lugwidth:")) {
      var lugwidthValue = currentUrl.split("lugwidth:")[1];
      var selectElement = $(".jsc-main_pdp_var_field [data-handle='lug-width-(lug-buckle)'] .select select");;
      if (selectElement.length) {
          selectElement.find("option").each(function() {
              if ($(this).val().includes(lugwidthValue)) {
                  $(this).prop("selected", true).trigger("change"); 
                  return false; 
              }
          });
      }
  }
}
// end: redirect to lug width selection from strap finder

// start: quick view
closeSearchDrawer = () => {
  $('#Search-Drawer').removeClass('active');
  $('body').removeClass('open-cc');
}

closeQuickView = (evt) => {
  $('body').removeClass('open-cc--product');
  $('#Product-Drawer').removeClass('active');
  setTimeout(function() {
    $('#Product-Drawer-Content').html('');
  }, 260);
}

showBisForm = (e) => {
  if ($(e).parents('#Product-Drawer-Content').length > 0) {
    var $overlay = $('.jsc-bis-form-wrapper .jsc-bis-overlay');
    var $modal = $('.jsc-bis-form-wrapper .jsc-bis-form-modal');
    var $title = $modal.find('.jsc-bis-title');
    var $selector = $modal.find('.jsc-bis-variant-selector');
    var $emailInput = $modal.find('.jsc-bis-email');
    var $message = $modal.find('.jsc-bis-message');
    var productJson = JSON.parse($(e).attr('data-product'));

    $title.text(productJson.title);
    $selector.html('');
    $.each(productJson.variants, function() {
      if(this.available == false) {
        var $option = $('<option></option>').val(this.id).text(this.title);
        $selector.append($option);
      }

    });
    $emailInput.val('');
    $message.removeClass('show');

    $overlay.addClass('active');
    $modal.addClass('active');
  }
}

hideBisForm = () => {
  var $overlay = $('.jsc-bis-form-wrapper .jsc-bis-overlay');
  var $modal = $('.jsc-bis-form-wrapper .jsc-bis-form-modal');

  $overlay.removeClass('active');
  $modal.removeClass('active');
}

subscribeBIS = (e) => {
  var emailRegex = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
  var email = $(e).parents('.jsc-bis-form-modal').find('.jsc-bis-email').val();
  var isEmailValid = false;
  var vid = parseInt($(e).parents('.jsc-bis-form-modal').find('.jsc-bis-variant-selector').val());
  var $message = $(e).parents('.jsc-bis-form-modal').find('.jsc-bis-message');
  var $listCheck = $(e).parents('.jsc-bis-form-modal').find('.jsc-list-checkbox');

  if (emailRegex.test(email)) {
    isEmailValid = true;
    $message.removeClass('show');
  }
  else {
    $message.html('Please input a valid email');
    $message.addClass('jsc-bis-error');
    $message.addClass('show');
  }

  if(isEmailValid == true) {
    const payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
                "type": "profile",
                "attributes": {
                    "email": email
                }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": "$shopify:::$default:::" + vid
            }
          }
        }
      }
    }

    var requestOptions = {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "revision":"2024-06-15"
      },
      body: JSON.stringify(payload),
    };

    fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=VbrHEs",requestOptions)
      .then(result => {
        console.log(result);
        $message.html("You're in! We'll let you know when it's back. <span onclick='hideBisForm();'>Close</span>");
        $message.addClass('jsc-bis-success');
        $message.addClass('show');
      })
      .catch(error => {
        console.log('error', error);
        $message.html("Error occurred! <span onclick='hideBisForm();'>Close</span>");
        $message.addClass('jsc-bis-error');
        $message.addClass('show');
      });

    if($listCheck.is(':checked')) {
      const subscribePayload = {
        "data": {
          "type": "subscription",
          "attributes": {
            "profile": {
              "data": {
                "type": "profile",
                "attributes": {
                  "email": email,
                  "properties": {
                    "newKey": "New Value"
                  }
                },
                "meta": {
                  "patch_properties": {
                    "append": {
                      "newKey": "New Value"
                    },
                    "unappend": {
                      "newKey": "New Value"
                    }
                  }
                }
              }
            }
          },
          "relationships": {
            "list": {
              "data": {
                "type": "list",
                "id": "Sj9eRY"
              }
            }
          }
        }
      }

      var subscribeOption = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "revision":"2024-07-15"
        },
        body: JSON.stringify(subscribePayload),
      };

      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=VbrHEs",subscribeOption)
        .then(result => console.log(result))
        .catch(error => console.log('error', error));
    }
  }
}
// end: quick view
/* === Personalisation CTA placement (product page) === */
(function () {
  var MOBILE = window.matchMedia('(max-width: 749px)');
  function $(q, root) { return (root || document).querySelector(q); }

  function getScope() { return document.querySelector('[id^="ProductInfo-"]'); }
  function getIds() {
    var scope = getScope();
    if (!scope) return null;
    var base = scope.id.replace('ProductInfo-', '');
    return {
      scopeSel: '#' + scope.id,
      SLOT_ID: 'pplr-slot-mobile-' + base,
      ORIG_ID: 'pplr-orig-' + base
    };
  }

  function findBtn(ids) {
    var scope = $(ids.scopeSel);
    if (!scope) return null;
    var list = scope.querySelectorAll('.product-personalizer');
    // Check if at least one element has a child button
    var hasButton = Array.from(list).some(el => el.querySelector('button'));
    if (!hasButton) return null;

    for (var i = 0; i < list.length; i++) {
      if (!list[i].closest('#' + ids.SLOT_ID) && !list[i].closest('#' + ids.ORIG_ID)) return list[i];
    }
    return list[0] || null;
  }

  function ensureSlots(ids) {
    var btn = findBtn(ids);
    if (!btn) return false;

    if (!document.getElementById(ids.ORIG_ID)) {
      var ph = document.createElement('div');
      ph.id = ids.ORIG_ID;
      btn.parentNode.insertBefore(ph, btn);
      ph.appendChild(btn);
    }

    if (!document.getElementById(ids.SLOT_ID)) {
      var slot = document.createElement('div');
      slot.id = ids.SLOT_ID;
      slot.className = 'pplr-slot-mobile';

      var cap = $(ids.scopeSel + ' .capitalize');
      if (cap) cap.appendChild(slot);
      else {
        var formLabel = $(ids.scopeSel + ' variant-selects .form__label');
        if (formLabel) formLabel.appendChild(slot);
        else ($(ids.scopeSel) || document.body).prepend(slot);
      }
      setTimeout(function () { relocate(ids); }, 0);
    }
    return true;
  }

  function relocate(ids) {
    var btn =
    Array.from(document.querySelectorAll(ids.scopeSel + ' #' + ids.ORIG_ID + ' .product-personalizer'))
         .find(el => el.querySelector('button')) ||
    Array.from(document.querySelectorAll(ids.scopeSel + ' #' + ids.SLOT_ID + ' .product-personalizer'))
         .find(el => el.querySelector('button')) ||
    findBtn(ids);
    var slot = document.getElementById(ids.SLOT_ID);
    var orig = document.getElementById(ids.ORIG_ID);
    if (!btn || !slot || !orig) return;
    if (MOBILE.matches) { if (btn.parentNode !== slot) slot.appendChild(btn); }
    else                { if (btn.parentNode !== orig) orig.appendChild(btn); }
  }

  function kick() {
    var ids = getIds();
    if (!ids) return;
    if (ensureSlots(ids)) relocate(ids);
  }

  // Run only on product page
  if (getScope()) {
    document.addEventListener('DOMContentLoaded', kick);
    new MutationObserver(kick).observe(getScope() || document.body, { childList: true, subtree: true });
    MOBILE.addEventListener('change', kick);
  }
})();



// start: multicolumn carousel
multicolumnCarouselPrev = (evt) => {
  var $arrow = $(evt);
  if ($arrow.hasClass('disabled')) {
    return;
  }
  var $slider = $arrow.parents('.multicolumn').find('.multicolumn-carousel');
  if ($slider.length > 0) {
    $slider.flickity();
    $slider.flickity('previous');
    updateMulticolumnArrowStates($slider);
  }
}

multicolumnCarouselNext = (evt) => {
  var $arrow = $(evt);
  if ($arrow.hasClass('disabled')) {
    return;
  }
  var $slider = $arrow.parents('.multicolumn').find('.multicolumn-carousel');
  if ($slider.length > 0) {
    $slider.flickity();
    $slider.flickity('next');
    updateMulticolumnArrowStates($slider);
  }
}

updateMulticolumnArrowStates = ($slider) => {
  var $multicolumn = $slider.parents('.multicolumn');
  var $prevArrow = $multicolumn.find('.jsc-flickity-prev');
  var $nextArrow = $multicolumn.find('.jsc-flickity-next');
  
  if ($slider.length > 0 && $slider.data('flickity')) {
    var flickity = $slider.data('flickity');
    
    // Get the current scroll position and content dimensions
    var scrollLeft = flickity.x;
    var containerWidth = flickity.size.innerWidth;
    var contentWidth = flickity.slideableWidth;
    
    // Calculate if we're at the beginning or end
    var isAtStart = scrollLeft >= 0;
    var isAtEnd = scrollLeft <= -(contentWidth - containerWidth);
    
    // Update prev arrow state
    if (isAtStart) {
      $prevArrow.addClass('disabled');
    } else {
      $prevArrow.removeClass('disabled');
    }
    
    // Update next arrow state
    if (isAtEnd) {
      $nextArrow.addClass('disabled');
    } else {
      $nextArrow.removeClass('disabled');
    }
  }
}

// Initialize arrow states when multicolumn carousel is created
$(document).ready(function() {
  $('.multicolumn-carousel').each(function() {
    var $slider = $(this);
    var $multicolumn = $slider.parents('.multicolumn');
    
    // Initialize flickity if not already done
    if (!$slider.data('flickity')) {
      $slider.flickity();
    }
    
    // Set up change event listener
    $slider.on('change.flickity', function() {
      updateMulticolumnArrowStates($slider);
    });
    
    // Set up select event listener for touch/swipe
    $slider.on('select.flickity', function() {
      updateMulticolumnArrowStates($slider);
    });
    
    // Set up scroll event listener for continuous updates with throttling
    var scrollTimeout;
    $slider.on('scroll.flickity', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        updateMulticolumnArrowStates($slider);
      }, 5);
    });
    
    // Set up resize event listener
    $slider.on('resize.flickity', function() {
      updateMulticolumnArrowStates($slider);
    });
    
    // Set initial arrow states with minimal delay to ensure Flickity is fully initialized
    setTimeout(function() {
      updateMulticolumnArrowStates($slider);
    }, 10);
  });
});
// end: multicolumn carousel

// Badged Products Block Flickity Initialization
badgedProductsFlickity = () => {
  $('.jsc-badged-products-carousel').flickity({
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    groupCells: false,
    imagesLoaded: true,
    adaptiveHeight: false,
    prevNextButtons: true,
    wrapAround: false
  });
}
// end: badged products carousel

mobileIconListFlickity = () =>{
  var $mobFlickity = $('.jsc-mob-icon-list-flickity');

  if ($mobFlickity.length > 0) { 
    $mobFlickity.flickity({
      cellAlign: 'left',
      draggable: true,
      contain: true,
      pageDots: false,
      imagesLoaded: true,
      adaptiveHeight: false,
      prevNextButtons: true,
      wrapAround: false
    });
  }
}

// Format Judge.me ratings to 1 decimal place
function formatJudgemeRatings() {
  document.querySelectorAll('.jdgm-prev-badge[data-average-rating]').forEach(function(badge) {
    var rating = parseFloat(badge.getAttribute('data-average-rating'));
    if (!isNaN(rating)) {
      badge.setAttribute('data-rating-display', rating.toFixed(1));
    }
  });
}

// Run on page load and observe for dynamically loaded content
document.addEventListener('DOMContentLoaded', function() {
  // Initial format
  setTimeout(formatJudgemeRatings, 500);
  
  // Observe for dynamically loaded content (like product recommendations)
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        setTimeout(formatJudgemeRatings, 100);
      }
    });
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
});

// Also run when Judge.me finishes loading
if (typeof jdgm !== 'undefined' && jdgm.hooks) {
  jdgm.hooks.add('widget:rendered', formatJudgemeRatings);
}

scrollVariantImagePickerToSelected = function($slider, cellSel) {
  var $selected = $slider.find(cellSel).filter(function() {
    return $(this).find('input.jsc-variant-image-picker__input:checked').length;
  }).first();
  if (!$selected.length) return;
  var flkty = $slider.data('flickity');
  if (flkty && typeof flkty.selectCell === 'function') {
    requestAnimationFrame(function() {
      flkty.selectCell($selected[0], false, true);
    });
  } else if ($selected[0] && $selected[0].scrollIntoView) {
    $selected[0].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }
};

/**
 * Strap length calculator (page template markup: [data-strap-finder]).
 * Uses document-level delegation so it works when the block is injected later (e.g. ?page=, section load).
 * Data source: Strap_Length_Matrix_0.1cm_adjusted.xlsx (grouped ranges per lug column).
 */
(function () {
  if (window.__jscStrapLengthFinderBound) return;
  window.__jscStrapLengthFinderBound = true;

  var RANGES_BY_LUG = {
    LT32: [
      { min: 12.0, max: 12.9, sizeKey: 'XS' },
      { min: 13.0, max: 14.9, sizeKey: 'S' },
      { min: 15.0, max: 16.4, sizeKey: 'M' },
      { min: 16.5, max: 18.4, sizeKey: 'L' },
      { min: 18.5, max: 19.9, sizeKey: 'XL' },
      { min: 20.0, max: 21.0, sizeKey: 'XXL' }
    ],
    '32_39': [
      { min: 12.0, max: 14.4, sizeKey: 'XS' },
      { min: 14.5, max: 14.9, sizeKey: 'S' },
      { min: 15.0, max: 16.4, sizeKey: 'M' },
      { min: 16.5, max: 18.4, sizeKey: 'L' },
      { min: 18.5, max: 19.9, sizeKey: 'XL' },
      { min: 20.0, max: 21.0, sizeKey: 'XXL' }
    ],
    '39_46': [
      { min: 12.0, max: 13.9, sizeKey: 'XS' },
      { min: 14.0, max: 15.4, sizeKey: 'S' },
      { min: 15.5, max: 17.9, sizeKey: 'M' },
      { min: 18.0, max: 18.9, sizeKey: 'L' },
      { min: 19.0, max: 20.5, sizeKey: 'XL' },
      { min: 20.6, max: 21.0, sizeKey: 'XXL' }
    ],
    '46_50': [
      { min: 12.0, max: 14.4, sizeKey: 'XS' },
      { min: 14.5, max: 15.9, sizeKey: 'S' },
      { min: 16.0, max: 17.9, sizeKey: 'M' },
      { min: 18.0, max: 19.9, sizeKey: 'L' },
      { min: 20.0, max: 21.0, sizeKey: 'XL' }
    ],
    '50_55': [
      { min: 12.0, max: 12.4, sizeKey: 'XXS' },
      { min: 12.5, max: 14.9, sizeKey: 'XS' },
      { min: 15.0, max: 16.9, sizeKey: 'S' },
      { min: 17.0, max: 18.9, sizeKey: 'M' },
      { min: 19.0, max: 20.4, sizeKey: 'L' },
      { min: 20.5, max: 21.0, sizeKey: 'XL' }
    ],
    GT55: [
      { min: 12.0, max: 12.4, sizeKey: 'XXS' },
      { min: 12.5, max: 14.4, sizeKey: 'XS' },
      { min: 14.5, max: 16.4, sizeKey: 'S' },
      { min: 16.5, max: 18.9, sizeKey: 'M' },
      { min: 19.0, max: 21.0, sizeKey: 'L' }
    ]
  };

  var STRAPS = {
    XXS: { label: 'Extra Extra Small', C: 85, D: 55, min: 12.0, max: 12.4 },
    XS: { label: 'Extra Small', C: 95, D: 60, min: 12.0, max: 14.4 },
    S: { label: 'Small', C: 105, D: 65, min: 14.5, max: 16.4 },
    M: { label: 'Medium', C: 115, D: 70, min: 16.5, max: 18.5 },
    L: { label: 'Large', C: 125, D: 75, min: 18.6, max: 20.0 },
    XL: { label: 'Extra Large', C: 135, D: 80, min: 18.5, max: 20.0 },
    XXL: { label: 'Extra Extra Large', C: 145, D: 85, min: 20.0, max: 21.0 }
  };

  function fillWristOptions(wristSelect, lugKey) {
    if (!wristSelect) return;
    wristSelect.innerHTML = '';
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = lugKey ? 'Select your wrist size' : 'Select lug-to-lug first';
    placeholder.disabled = true;
    placeholder.selected = true;
    wristSelect.appendChild(placeholder);
    if (!lugKey) return;
    var ranges = RANGES_BY_LUG[lugKey];
    if (!ranges) return;
    for (var i = 0; i < ranges.length; i++) {
      var r = ranges[i];
      var opt = document.createElement('option');
      opt.value = r.sizeKey;
      opt.textContent = r.min + ' – ' + r.max + ' cm';
      wristSelect.appendChild(opt);
    }
  }

  function recommendFromWristValue(wristOptionValue) {
    var sizeKey = wristOptionValue;
    if (!sizeKey || !STRAPS[sizeKey]) return null;
    return { type: 'size', size: sizeKey };
  }

  function showStrapFinderError(resultEl, msg) {
    if (!resultEl) return;
    resultEl.hidden = false;
    resultEl.innerHTML =
      '<div class="sf-title" style="font-size:16px">' +
      msg +
      '</div><p class="sf-sub">Please select the missing fields and try again.</p>';
  }

  function renderStrapFinderResult(resultEl, payload) {
    if (!resultEl) return;
    resultEl.hidden = false;
    if (payload.type === 'custom') {
      resultEl.innerHTML =
        '<div class="sf-title">Custom strap length</div><p class="sf-sub">' + payload.msg + '</p>';
      return;
    }
    var s = STRAPS[payload.size];
    resultEl.innerHTML =
      '<div class="sf-title">' +
      s.label +
      ' Strap</div><p class="sf-sub">Long end: ' +
      s.C +
      'mm • Short end: ' +
      s.D +
      'mm</p><hr class="sf-hr" /><p class="sf-small">Recommended for wrists measuring ' +
      s.min +
      '–' +
      s.max +
      ' cm.</p>';
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-sf-l2l]')) return;
    var root = t.closest('[data-strap-finder]');
    if (!root) return;
    var wrist = root.querySelector('[data-sf-wrist]');
    if (!wrist) return;
    wrist.value = '';
    fillWristOptions(wrist, t.value);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var root = t.closest('[data-strap-finder]');
    if (!root) return;

    var helpBtn = t.closest('[data-sf-toggle-help]');
    if (helpBtn) {
      var key = helpBtn.getAttribute('data-sf-toggle-help');
      var panel = root.querySelector('[data-sf-help="' + key + '"]');
      if (!panel) return;
      var willOpen = panel.hidden === true;
      panel.hidden = !willOpen;
      helpBtn.setAttribute('aria-expanded', String(willOpen));
      return;
    }

    if (t.closest('[data-sf-submit]')) {
      var l2lEl = root.querySelector('[data-sf-l2l]');
      var wristEl = root.querySelector('[data-sf-wrist]');
      var resultEl = root.querySelector('[data-sf-result]');
      if (!l2lEl || !wristEl || !resultEl) return;
      if (!l2lEl.value) {
        showStrapFinderError(resultEl, 'Please select your lug-to-lug range.');
        return;
      }
      if (!wristEl.value) {
        showStrapFinderError(resultEl, 'Please select your wrist size.');
        return;
      }
      var payload = recommendFromWristValue(wristEl.value);
      if (!payload) {
        showStrapFinderError(resultEl, 'Unable to generate a recommendation — please check your inputs.');
        return;
      }
      renderStrapFinderResult(resultEl, payload);
      resultEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return;
    }

    if (t.closest('[data-sf-reset]')) {
      var l2l = root.querySelector('[data-sf-l2l]');
      var wrist = root.querySelector('[data-sf-wrist]');
      var resultEl = root.querySelector('[data-sf-result]');
      if (l2l) l2l.value = '';
      if (wrist) {
        wrist.value = '';
        fillWristOptions(wrist, '');
      }
      ['wrist', 'l2l'].forEach(function (k) {
        var panel = root.querySelector('[data-sf-help="' + k + '"]');
        var btn = root.querySelector('[data-sf-toggle-help="' + k + '"]');
        if (panel) panel.hidden = true;
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      if (resultEl) {
        resultEl.hidden = true;
        resultEl.innerHTML = '';
      }
    }
  });
})();